// // import React, { useEffect, useState } from "react";
// // import { motion } from "framer-motion";
// // import { Reveal, staggerContainer, revealUp, zoomIn } from "../common/Reveal";
// // import { useTheme } from "../../context/ThemeContext";

// // /* ------------------------------------------------------------------ *
// //  * Content taken from: "web page Gurukul English Medium School.docx"
// //  * Recommended Webpage Structure — Gurukul English Medium School &
// //  * Junior College, Abdul Lat
// //  * Every line of copy of the document is rendered below. Image areas
// //  * are left blank and marked with a border (placeholders).
// //  * ------------------------------------------------------------------ */

// // const HERO_LEAD =
// //   "Established in 2008, Gurukul English Medium School & Junior College, Abdul Lat provides a complete Nursery to Grade 12 educational journey that combines academic excellence, advanced learning, sports, values and holistic development.";

// // const HERO_CHIPS = [
// //   "18+ Years",
// //   "770+ Students",
// //   "Nursery–12",
// //   "100% Board Results*",
// // ];

// // const HERO_NOTE = "*100% SSC & HSC results consecutively for the last 10 years.";

// // const GLANCE = [
// //   { value: 18, suffix: "+", label: "Years of Journey" },
// //   { value: 770, suffix: "+", label: "Students" },
// //   { value: 2008, suffix: "", label: "Established" },
// //   { text: "Nursery–12", label: "Complete Schooling" },
// //   { value: 10, suffix: " Years", label: "100% SSC & HSC Results" },
// // ];

// // const TIMELINE = [
// //   {
// //     year: "2008",
// //     text:
// //       "Gurukul English Medium School & Junior College begins its journey with 54 students.",
// //   },
// //   {
// //     year: "Growth & Expansion",
// //     text:
// //       "The institution steadily expands its academic programmes, infrastructure, technology and student opportunities.",
// //   },
// //   {
// //     year: "Today",
// //     text:
// //       "770+ students from Nursery to Grade 12, supported by a comprehensive educational ecosystem.",
// //   },
// // ];

// // const JOURNEY_TEXT =
// //   "What began with 54 students has grown into a thriving K–12 institution through the trust of parents, dedication of teachers and a continuous commitment to educational excellence.";

// // const ACADEMIC_PARAGRAPH =
// //   "Our academic approach combines concept-based teaching, regular assessment, individual attention, doubt-solving, remedial support and structured examination preparation. Our focus extends beyond examination results to developing knowledge, confidence, discipline and strong learning habits.";

// // const ACADEMIC_CARDS = [
// //   {
// //     title: "Conceptual Learning",
// //     text: "Strong understanding rather than rote learning.",
// //   },
// //   {
// //     title: "Individual Attention",
// //     text: "Monitoring and support according to student needs.",
// //   },
// //   {
// //     title: "Examination Readiness",
// //     text: "Systematic preparation and continuous assessment.",
// //   },
// // ];

// // const FUTURE_CARDS = [
// //   {
// //     title: "Digital Classrooms",
// //     text: "Interactive technology-enabled learning.",
// //   },
// //   {
// //     title: "Robotics Lab",
// //     text: "Exploration of robotics, automation and problem-solving.",
// //   },
// //   {
// //     title: "Advanced STEM Labs",
// //     text: "Hands-on Science, Technology, Engineering and Mathematics.",
// //   },
// //   {
// //     title: "Computer Labs",
// //     text: "Modern computing facilities for digital literacy and technology skills.",
// //   },
// // ];

// // const FUTURE_STATEMENT =
// //   "We believe today's education must prepare students not only for today's opportunities, but for a rapidly changing future.";

// // const SPORT_LEVELS = ["Taluka", "District", "State", "National"];

// // const SPORTS_TEXT =
// //   "Our students have achieved success in school sports competitions from Taluka to National level.";

// // const SPORTS_GROUPS = [
// //   {
// //     title: "Combat & Fitness",
// //     icon: "🥋",
// //     items: [
// //       "Boxing",
// //       "Taekwondo",
// //       "Karate",
// //       "Yoga",
// //       "Zumba",
// //       "Lathi-Kathi",
// //       "Fencing",
// //     ],
// //   },
// //   {
// //     title: "Team & Outdoor Sports",
// //     icon: "🏆",
// //     items: [
// //       "Kho-Kho",
// //       "Kabaddi",
// //       "Volleyball",
// //       "Football",
// //       "Throwball",
// //       "Cricket",
// //     ],
// //   },
// //   {
// //     title: "Indoor",
// //     icon: "🏓",
// //     items: ["Table Tennis", "Other indoor activities"],
// //   },
// // ];

// // const SPORTS_HIGHLIGHT = [
// //   "Dedicated coaches",
// //   "Large playground",
// //   "Regular training",
// //   "Competitive opportunities",
// // ];

// // const SPORT_PHOTOS = [
// //   { label: "Boxing", wide: true },
// //   { label: "Kho-Kho" },
// //   { label: "Cricket" },
// //   { label: "Yoga" },
// //   { label: "Volleyball" },
// //   { label: "Table Tennis", wide: true },
// // ];

// // const BEYOND_CARDS = [
// //   { title: "Creativity", icon: "🎨" },
// //   { title: "Communication", icon: "🗣️" },
// //   { title: "Confidence", icon: "🌟" },
// //   { title: "Teamwork", icon: "🤝" },
// //   { title: "Self-Expression", icon: "🎭" },
// //   { title: "Discipline", icon: "🎯" },
// // ];

// // const BEYOND_TEXT =
// //   "Our co-curricular opportunities encourage students to explore their interests, discover their strengths and develop skills that extend beyond the classroom.";

// // const GALLERY_ITEMS = [
// //   "Main Campus",
// //   "Digital Classroom",
// //   "Robotics Lab",
// //   "STEM Lab",
// //   "Computer Lab",
// //   "Playground",
// //   "Multipurpose Hall",
// //   "Amphitheatre",
// // ];

// // const CAMPUS_TEXT =
// //   "A picturesque campus with modern educational infrastructure provides students with dedicated spaces to learn, experiment, play, perform and grow.";

// // const SPACES = [
// //   {
// //     title: "Multipurpose Hall",
// //     caption: "Multipurpose Hall image",
// //     items: [
// //       "Seminars",
// //       "Workshops",
// //       "Indoor programmes",
// //       "Parent meetings",
// //       "Cultural activities",
// //       "Student presentations",
// //     ],
// //   },
// //   {
// //     title: "Outdoor Amphitheatre",
// //     caption: "Outdoor Amphitheatre image",
// //     items: [
// //       "Cultural programmes",
// //       "Performances",
// //       "Celebrations",
// //       "Student presentations",
// //       "School gatherings",
// //     ],
// //   },
// // ];

// // const CARE_CARDS = [
// //   {
// //     icon: "🚌",
// //     title: "Safe Transportation",
// //     text:
// //       "Safe and secure school bus facility for students travelling to and from campus.",
// //   },
// //   {
// //     icon: "🏠",
// //     title: "Residential Facilities",
// //     text:
// //       "Separate hostel facilities for boys and girls in a structured and supportive environment.",
// //   },
// //   {
// //     icon: "🕒",
// //     title: "Day Boarding",
// //     text:
// //       "A convenient option for students spending an extended day on campus.",
// //   },
// //   {
// //     icon: "🍽️",
// //     title: "Meals & Snacks",
// //     text: "Nutritious meals and snacks for day-boarder students.",
// //   },
// // ];

// // const CARE_MESSAGE =
// //   "We understand that parents want their children to be not only well educated, but also safe, comfortable, cared for and supported throughout the school day.";

// // const ADVANTAGE = [
// //   { icon: "📚", title: "Academics", text: "Strong foundations & consistent results" },
// //   { icon: "💻", title: "Technology", text: "Digital • Robotics • STEM • Computing" },
// //   { icon: "🏅", title: "Sports", text: "Dedicated coaching & competitive opportunities" },
// //   { icon: "🎨", title: "Co-Curricular", text: "Creativity • Communication • Confidence" },
// //   { icon: "🏫", title: "Infrastructure", text: "Modern classrooms, labs & activity spaces" },
// //   { icon: "🛡️", title: "Student Care", text: "Transport • Day Boarding • Meals" },
// //   { icon: "🛏️", title: "Residential", text: "Separate boys' & girls' hostel facilities" },
// //   { icon: "🙏", title: "Values", text: "Indian culture • Discipline • Character" },
// // ];

// // const WHY_LIST = [
// //   "18+ Years of Educational Journey",
// //   "770+ Students",
// //   "Nursery to Grade 12",
// //   "10 Consecutive Years of 100% SSC & HSC Results",
// //   "Advanced Digital, Robotics & STEM Learning",
// //   "Taluka to National-Level Sports Achievements",
// //   "Dedicated Sports Coaches",
// //   "Wide Range of Co-Curricular Activities",
// //   "Modern Infrastructure",
// //   "Safe & Secure Transportation",
// //   "Separate Boys' & Girls' Hostels",
// //   "Day Boarding with Meals & Snacks",
// //   "Indian Values & Discipline",
// // ];

// // const PHILOSOPHY_PARAGRAPHS = [
// //   "At Gurukul, we recognise that every child is unique. Some shine in academics, some in sports, technology, creativity or performance.",
// //   "Our role is to provide the environment, guidance, opportunities and encouragement that help each child discover their strengths and pursue excellence.",
// // ];

// // const PHILOSOPHY_STATEMENT =
// //   "We prepare students not only for examinations, but for the opportunities and responsibilities of life.";

// // /* ------------------------------------------------------------------ */

// // const Counter = ({ value, suffix = "", duration = 1600 }) => {
// //   const [count, setCount] = useState(0);
// //   const [started, setStarted] = useState(false);
// //   const anchorRef = React.useRef(null);

// //   useEffect(() => {
// //     const el = anchorRef.current;
// //     if (!el || started) return undefined;
// //     const observer = new IntersectionObserver(
// //       (entries) => {
// //         if (entries[0].isIntersecting) {
// //           setStarted(true);
// //           observer.disconnect();
// //         }
// //       },
// //       { threshold: 0.2 }
// //     );
// //     observer.observe(el);
// //     return () => observer.disconnect();
// //   }, [started]);

// //   useEffect(() => {
// //     if (!started) return undefined;
// //     let frame;
// //     const startTime = performance.now();
// //     const tick = (now) => {
// //       const p = Math.min((now - startTime) / duration, 1);
// //       const eased = 1 - Math.pow(1 - p, 3);
// //       setCount(Math.round(value * eased));
// //       if (p < 1) frame = requestAnimationFrame(tick);
// //     };
// //     frame = requestAnimationFrame(tick);
// //     return () => cancelAnimationFrame(frame);
// //   }, [started, value, duration]);

// //   return (
// //     <span ref={anchorRef}>
// //       {count}
// //       {suffix}
// //     </span>
// //   );
// // };

// // // Blank, bordered area reserved for an image.
// // // size: hero | feature | large | medium | small  (responsive heights)
// // const Placeholder = ({ size = "medium", caption, radius = "1rem" }) => (
// //   <div style={{ width: "100%" }}>
// //     <div
// //       role="img"
// //       aria-label={caption ? `Image placeholder: ${caption}` : "Image placeholder"}
// //       className={`ga-ph ga-ph--${size}`}
// //       style={{ borderRadius: radius }}
// //     />
// //     {caption ? <div className="ga-ph-caption">{caption}</div> : null}
// //   </div>
// // );

// // // Image tile with a label bar — used for the sports photo grid.
// // const PhotoTile = ({ label }) => (
// //   <div className="ga-tile">
// //     <div
// //       role="img"
// //       aria-label={`Image placeholder: ${label}`}
// //       className="ga-ph ga-ph--medium"
// //     />
// //     <span className="ga-tile-label">{label}</span>
// //   </div>
// // );

// // const SectionHead = ({ title, sub }) => (
// //   <motion.div
// //     className="ga-head"
// //     variants={staggerContainer}
// //     initial="hidden"
// //     whileInView="show"
// //     viewport={{ once: true }}
// //   >
// //     <Reveal as={motion.h2} variants={revealUp} className="ga-title">
// //       {title}
// //     </Reveal>
// //     {sub ? (
// //       <Reveal as={motion.p} variants={revealUp} className="ga-sub">
// //         {sub}
// //       </Reveal>
// //     ) : null}
// //   </motion.div>
// // );

// // const EnglishAcademyShowcase = () => {
// //   const { colors } = useTheme();

// //   const goTo = (id) => {
// //     const el = document.getElementById(id);
// //     if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
// //   };

// //   const rootStyle = {
// //     "--ga-primary": colors.primary,
// //     "--ga-primary-dark": colors.primaryDark,
// //     "--ga-text": colors.text,
// //     "--ga-text2": colors.textSecondary,
// //     "--ga-bg": colors.background,
// //     "--ga-bg-alt": colors.backgroundAlt,
// //     "--ga-card": colors.card,
// //     "--ga-border": colors.border,
// //     "--ga-shadow": colors.cardShadow,
// //   };

// //   return (
// //     <div className="ga-root" style={rootStyle}>
// //       <style>{`
// //         .ga-root { position: relative; color: var(--ga-text); }
// //         .ga-section { padding: 4.5rem 1.5rem; scroll-margin-top: 116px; position: relative; }
// //         .ga-section--alt { background: var(--ga-bg-alt); }
// //         .ga-section--plain { background: var(--ga-bg); }
// //         .ga-wrap { max-width: 1200px; margin: 0 auto; }

// //         .ga-head { text-align: center; margin-bottom: 2.75rem; }
// //         .ga-title {
// //           font-size: clamp(1.75rem, 3.6vw, 2.6rem); font-weight: 700;
// //           line-height: 1.2; margin: 0 0 0.6rem; color: var(--ga-text);
// //         }
// //         .ga-sub { font-size: 1.08rem; color: var(--ga-text2); max-width: 840px; margin: 0 auto; }

// //         .ga-card {
// //           background: var(--ga-card); border: 1px solid var(--ga-border);
// //           border-radius: 1rem; padding: 1.5rem; box-shadow: var(--ga-shadow);
// //           transition: transform .3s ease, box-shadow .3s ease, border-color .3s ease;
// //         }
// //         .ga-card:hover {
// //           transform: translateY(-6px); border-color: var(--ga-primary);
// //           box-shadow: 0 16px 32px rgba(3, 105, 161, 0.16);
// //         }
// //         .ga-grid { display: grid; gap: 1.5rem; }
// //         .ga-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
// //         .ga-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
// //         .ga-grid-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
// //         .ga-grid-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
// //         .ga-grid-6 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
// //         .ga-grid-8 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
// //         .ga-ph {
// //           width: 100%; border: 2px dashed var(--ga-primary); display: block;
// //           background-image: repeating-linear-gradient(
// //             135deg,
// //             rgba(14, 165, 233, 0.10) 0 10px,
// //             rgba(14, 165, 233, 0) 10px 22px
// //           );
// //         }
// //         /* Responsive image sizes — big on desktop, compact on mobile */
// //         .ga-ph--hero { height: clamp(300px, 42vw, 560px); }
// //         .ga-ph--feature { height: clamp(300px, 40vw, 520px); }
// //         .ga-ph--large { height: clamp(260px, 28vw, 420px); }
// //         .ga-ph--medium { height: clamp(210px, 19vw, 320px); }
// //         .ga-ph--small { height: clamp(180px, 16vw, 260px); }
// //         .ga-ph-caption {
// //           margin-top: 0.6rem; font-size: 0.85rem; color: var(--ga-text2);
// //           text-align: center; font-weight: 500;
// //         }

// //         /* Sports photo grid */
// //         .ga-mosaic { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.25rem; }
// //         .ga-tile {
// //           position: relative; overflow: hidden; border-radius: 1rem;
// //           box-shadow: var(--ga-shadow);
// //         }
// //         .ga-tile--wide { grid-column: span 2; }
// //         .ga-tile .ga-ph {
// //           height: clamp(220px, 20vw, 340px);
// //           transition: transform .45s ease, border-color .45s ease;
// //           background-color: var(--ga-card);
// //         }
// //         .ga-tile:hover .ga-ph { transform: scale(1.05); border-color: var(--ga-primary-dark); }
// //         .ga-tile-label {
// //           position: absolute; left: 0; right: 0; bottom: 0;
// //           padding: 1.8rem 0.9rem 0.7rem; font-size: 0.92rem; font-weight: 600;
// //           color: #ffffff; letter-spacing: 0.02em;
// //           background: linear-gradient(to top, rgba(3, 105, 161, 0.92) 0%, rgba(3, 105, 161, 0) 100%);
// //           transform: translateY(4px); transition: transform .35s ease;
// //         }
// //         .ga-tile:hover .ga-tile-label { transform: translateY(0); }

// //         .ga-chip {
// //           display: inline-flex; align-items: center; gap: 0.4rem;
// //           padding: 0.45rem 1rem; border-radius: 999px; font-size: 0.92rem;
// //           font-weight: 600; color: var(--ga-primary-dark);
// //           background: rgba(14, 165, 233, 0.10); border: 1px solid rgba(14, 165, 233, 0.35);
// //           transition: transform .25s ease, background .25s ease;
// //         }
// //         .ga-chip:hover { transform: translateY(-3px); background: rgba(14, 165, 233, 0.18); }

// //         .ga-btn {
// //           display: inline-flex; align-items: center; justify-content: center;
// //           gap: 0.5rem; padding: 0.85rem 1.7rem; border-radius: 0.7rem;
// //           font-family: inherit; font-size: 1rem; font-weight: 600; cursor: pointer;
// //           border: none; transition: transform .25s ease, box-shadow .25s ease, background .25s ease;
// //         }
// //         .ga-btn:hover { transform: translateY(-3px); }
// //         .ga-btn-primary {
// //           background: linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%);
// //           color: #fff; box-shadow: 0 10px 20px rgba(3, 105, 161, 0.3);
// //         }
// //         .ga-btn-primary:hover { box-shadow: 0 14px 26px rgba(3, 105, 161, 0.4); }
// //         .ga-btn-outline {
// //           background: transparent; color: var(--ga-primary-dark);
// //           border: 2px solid var(--ga-primary);
// //         }
// //         .ga-btn-outline:hover { background: rgba(14, 165, 233, 0.12); }
// //         .ga-btn-light { background: #ffffff; color: #0369a1; box-shadow: 0 10px 20px rgba(0,0,0,0.18); }
// //         .ga-btn-ghost { background: transparent; color: #ffffff; border: 2px solid rgba(255,255,255,0.85); }
// //         .ga-btn-ghost:hover { background: rgba(255,255,255,0.15); }

// //         /* Hero */
// //         .ga-hero {
// //           background: linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%);
// //           color: #ffffff; padding-top: 3.5rem; padding-bottom: 3.5rem;
// //         }
// //         .ga-hero .ga-ph { border-color: rgba(255,255,255,0.8); background-image: repeating-linear-gradient(135deg, rgba(255,255,255,0.14) 0 10px, rgba(255,255,255,0) 10px 22px); }
// //         .ga-hero-title {
// //           font-size: clamp(2rem, 5vw, 3.4rem); font-weight: 800; line-height: 1.15;
// //           margin: 2rem 0 1rem; color: #ffffff;
// //         }
// //         .ga-hero-lead { font-size: 1.1rem; line-height: 1.7; color: rgba(255,255,255,0.92); max-width: 900px; margin: 0 0 1.6rem; }
// //         .ga-hero-chips { display: flex; flex-wrap: wrap; gap: 0.7rem; margin-bottom: 1.8rem; }
// //         .ga-hero-chips .ga-chip {
// //           background: rgba(255,255,255,0.16); border-color: rgba(255,255,255,0.5); color: #ffffff;
// //           font-size: 1rem; padding: 0.55rem 1.1rem;
// //         }
// //         .ga-hero-chips .ga-chip:hover { background: rgba(255,255,255,0.28); }
// //         .ga-actions { display: flex; flex-wrap: wrap; gap: 1rem; margin-bottom: 1.2rem; }
// //         .ga-note { font-size: 0.9rem; color: rgba(255,255,255,0.85); margin: 0; }

// //         /* Glance */
// //         .ga-stat { text-align: center; padding: 1.75rem 1rem; }
// //         .ga-stat-value {
// //           font-size: clamp(2rem, 4vw, 2.75rem); font-weight: 800;
// //           background: linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%);
// //           -webkit-background-clip: text; background-clip: text;
// //           -webkit-text-fill-color: transparent; line-height: 1.1;
// //         }
// //         .ga-stat-label { margin-top: 0.5rem; color: var(--ga-text2); font-size: 0.98rem; }

// //         /* Journey */
// //         .ga-timeline { display: flex; flex-wrap: wrap; gap: 1rem; align-items: stretch; }
// //         .ga-timeline .ga-node { flex: 1 1 260px; }
// //         .ga-node { position: relative; text-align: left; }
// //         .ga-node-year {
// //           display: inline-block; padding: 0.3rem 0.9rem; border-radius: 999px;
// //           background: linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%);
// //           color: #fff; font-weight: 700; font-size: 0.95rem; margin-bottom: 0.9rem;
// //         }
// //         .ga-node-arrow {
// //           display: flex; align-items: center; justify-content: center;
// //           color: var(--ga-primary); font-size: 1.6rem; font-weight: 700;
// //         }
// //         .ga-quote {
// //           background: var(--ga-card); border-left: 5px solid var(--ga-primary);
// //           border-radius: 0.75rem; padding: 1.4rem 1.6rem; color: var(--ga-text);
// //           font-size: 1.05rem; line-height: 1.75; box-shadow: var(--ga-shadow);
// //         }

// //         /* Big 100% visual */
// //         .ga-percent {
// //           display: flex; flex-direction: column; align-items: center; justify-content: center;
// //           text-align: center; padding: 2.5rem 1.5rem; border-radius: 1rem;
// //           background: linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%); color: #fff;
// //           box-shadow: 0 18px 36px rgba(3, 105, 161, 0.28);
// //         }
// //         .ga-percent-number { font-size: clamp(4rem, 10vw, 6rem); font-weight: 800; line-height: 1; }
// //         .ga-percent-years { font-size: 1.15rem; font-weight: 600; margin-top: 0.75rem; opacity: 0.95; }
// //         .ga-percent-label { font-size: 1.35rem; font-weight: 700; margin-top: 0.35rem; }

// //         .ga-icon {
// //           width: 52px; height: 52px; border-radius: 0.9rem; display: flex;
// //           align-items: center; justify-content: center; font-size: 1.5rem;
// //           background: rgba(14, 165, 233, 0.12); border: 1px solid rgba(14, 165, 233, 0.3);
// //           margin-bottom: 1rem;
// //         }
// //         .ga-card-title { font-size: 1.2rem; font-weight: 700; color: var(--ga-text); margin: 0 0 0.5rem; }
// //         .ga-card-text { color: var(--ga-text2); margin: 0; line-height: 1.65; }

// //         .ga-statement {
// //           margin-top: 2rem; text-align: center; padding: 1.6rem 1.8rem;
// //           border-radius: 1rem; font-size: 1.12rem; line-height: 1.7; font-weight: 500;
// //           background: rgba(14, 165, 233, 0.10); border: 1px solid rgba(14, 165, 233, 0.35);
// //           color: var(--ga-text);
// //         }

// //         .ga-levels { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 0.6rem; margin: 1.5rem 0; }
// //         .ga-level-arrow { color: var(--ga-primary); font-weight: 800; font-size: 1.2rem; }
// //         .ga-sports-list { display: flex; flex-wrap: wrap; gap: 0.55rem; margin-top: 1rem; }
// //         .ga-sports-list .ga-chip { cursor: default; }

// //         .ga-check {
// //           display: flex; align-items: flex-start; gap: 0.75rem; padding: 0.85rem 1rem;
// //           border-radius: 0.75rem; background: var(--ga-card); border: 1px solid var(--ga-border);
// //           transition: transform .25s ease, border-color .25s ease, box-shadow .25s ease;
// //         }
// //         .ga-check:hover { transform: translateX(6px); border-color: var(--ga-primary); box-shadow: 0 10px 20px rgba(3,105,161,0.12); }
// //         .ga-check-mark {
// //           flex: 0 0 auto; width: 26px; height: 26px; border-radius: 50%;
// //           display: flex; align-items: center; justify-content: center;
// //           background: linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%);
// //           color: #fff; font-size: 0.85rem; font-weight: 700;
// //         }
// //         .ga-check-text { color: var(--ga-text); font-weight: 500; line-height: 1.5; }

// //         .ga-space-list { list-style: none; padding: 0; margin: 1rem 0 0; display: grid; gap: 0.5rem; }
// //         .ga-space-list li { display: flex; gap: 0.6rem; align-items: center; color: var(--ga-text2); }
// //         .ga-space-list li::before { content: "▸"; color: var(--ga-primary); font-weight: 700; }

// //         .ga-final {
// //           background: linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%);
// //           color: #fff; text-align: center;
// //         }
// //         .ga-final .ga-ph { border-color: rgba(255,255,255,0.8); background-image: repeating-linear-gradient(135deg, rgba(255,255,255,0.14) 0 10px, rgba(255,255,255,0) 10px 22px); }
// //         .ga-final .ga-ph-caption { color: rgba(255,255,255,0.85); }
// //         .ga-final-title { font-size: clamp(1.8rem, 4vw, 2.8rem); font-weight: 800; line-height: 1.2; margin: 2rem 0 1rem; color: #fff; }
// //         .ga-final-school { font-size: 1.15rem; font-weight: 600; color: rgba(255,255,255,0.95); margin: 0 0 0.6rem; }
// //         .ga-badge {
// //           display: inline-block; padding: 0.4rem 1.1rem; border-radius: 999px;
// //           background: rgba(255,255,255,0.18); border: 1px solid rgba(255,255,255,0.5);
// //           font-weight: 600; margin-bottom: 1.6rem;
// //         }
// //         .ga-tagline { margin-top: 1.5rem; font-size: 1.1rem; font-style: italic; color: rgba(255,255,255,0.92); }

// //         .ga-center { text-align: center; }
// //         .ga-mt-2 { margin-top: 2rem; }
// //         .ga-mb-1 { margin-bottom: 1rem; }

// //         @media (min-width: 1025px) {
// //           .ga-mosaic { grid-template-columns: repeat(4, 1fr); }
// //         }

// //         @media (max-width: 1024px) {
// //           .ga-grid { gap: 1.25rem; }
// //           .ga-grid-3, .ga-grid-4 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
// //           .ga-grid-5 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
// //           .ga-grid-5 > :last-child { grid-column: span 2; }
// //           .ga-grid-8 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
// //         }

// //         @media (max-width: 768px) {
// //           .ga-section { padding: 3rem 1.1rem; scroll-margin-top: 100px; }
// //           .ga-head { margin-bottom: 2rem; }
// //           .ga-grid { gap: 1rem; }
// //           .ga-grid-2, .ga-grid-6, .ga-grid-8 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
// //           .ga-node-arrow { transform: rotate(90deg); }
// //           .ga-mosaic { gap: 1rem; }
// //           .ga-ph--hero { height: 240px; }
// //           .ga-ph--feature { height: 240px; }
// //           .ga-ph--large { height: 210px; }
// //           .ga-ph--medium { height: 190px; }
// //           .ga-ph--small { height: 160px; }
// //           .ga-tile .ga-ph { height: 180px; }
// //           .ga-tile--wide .ga-ph { height: 210px; }
// //           .ga-actions { gap: 0.75rem; }
// //           .ga-actions .ga-btn { flex: 1 1 220px; }
// //         }

// //         @media (max-width: 560px) {
// //           .ga-grid-2, .ga-grid-3, .ga-grid-4 { grid-template-columns: minmax(0, 1fr); }
// //           .ga-grid-5 > :last-child { grid-column: span 1; }
// //           .ga-stat-value { font-size: 1.7rem; }
// //           .ga-percent { padding: 2rem 1rem; }
// //         }
// //       `}</style>

// //       {/* 01 — HERO */}
// //       <section id="ga-hero" className="ga-section ga-hero">
// //         <div className="ga-wrap">
// //           <Placeholder size="hero" caption="Full-width photograph / video of the campus with students" />

// //           <h1 className="ga-hero-title">
// //             {"Strong Foundations. Advanced Learning. Limitless Possibilities."}
// //           </h1>
// //           <p className="ga-hero-lead">{HERO_LEAD}</p>

// //           <div className="ga-hero-chips">
// //             {HERO_CHIPS.map((chip) => (
// //               <span className="ga-chip" key={chip}>
// //                 {chip}
// //               </span>
// //             ))}
// //           </div>

// //           <div className="ga-actions">
// //             <button className="ga-btn ga-btn-light" onClick={() => goTo("ga-glance")}>
// //               Explore Gurukul
// //             </button>
// //             <button className="ga-btn ga-btn-ghost" onClick={() => goTo("admission-inquiry")}>
// //               Admission Enquiry
// //             </button>
// //           </div>
// //           <p className="ga-note">{HERO_NOTE}</p>
// //         </div>
// //       </section>

// //       {/* 02 — SCHOOL AT A GLANCE */}
// //       <section id="ga-glance" className="ga-section ga-section--alt">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="School at a Glance"
// //             sub="This gives parents an immediate understanding of the institution."
// //           />
// //           <motion.div
// //             className="ga-grid ga-grid-5"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {GLANCE.map((stat) => (
// //               <Reveal as={motion.div} key={stat.label} variants={zoomIn} className="ga-card ga-stat">
// //                 <div className="ga-stat-value">
// //                   {stat.text ? stat.text : <Counter value={stat.value} suffix={stat.suffix} />}
// //                 </div>
// //                 <div className="ga-stat-label">{stat.label}</div>
// //               </Reveal>
// //             ))}
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* 03 — OUR JOURNEY */}
// //       <section id="ga-journey" className="ga-section ga-section--plain">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Our Journey"
// //             sub="From 54 Students to 770+ Students"
// //           />

// //           <div className="ga-timeline">
// //             {TIMELINE.map((node, index) => (
// //               <React.Fragment key={node.year}>
// //                 <Reveal as={motion.div} variants={zoomIn} className="ga-card ga-node">
// //                   <span className="ga-node-year">{node.year}</span>
// //                   <p className="ga-card-text">{node.text}</p>
// //                 </Reveal>
// //                 {index < TIMELINE.length - 1 ? (
// //                   <div className="ga-node-arrow" aria-hidden="true">
// //                     →
// //                   </div>
// //                 ) : null}
// //               </React.Fragment>
// //             ))}
// //           </div>

// //           <Reveal as={motion.div} variants={revealUp} className="ga-quote ga-mt-2">
// //             {JOURNEY_TEXT}
// //           </Reveal>

// //           <div className="ga-grid ga-grid-2 ga-mt-2">
// //             <Placeholder size="large" caption="Old photograph" />
// //             <Placeholder size="large" caption="Present-day campus photograph" />
// //           </div>
// //         </div>
// //       </section>

// //       {/* 04 — ACADEMIC EXCELLENCE */}
// //       <section id="ga-academics" className="ga-section ga-section--alt">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Academic Excellence"
// //             sub="Strong Foundations. Consistent Results."
// //           />

// //           <div className="ga-grid ga-grid-2" style={{ alignItems: "stretch" }}>
// //             <Reveal as={motion.div} variants={zoomIn}>
// //               <div className="ga-percent">
// //                 <div className="ga-percent-number">100%</div>
// //                 <div className="ga-percent-years">10 Consecutive Years</div>
// //                 <div className="ga-percent-label">100% SSC &amp; HSC Board Results</div>
// //               </div>
// //             </Reveal>
// //             <Reveal as={motion.div} variants={revealUp} className="ga-card" style={{ display: "flex", alignItems: "center" }}>
// //               <p className="ga-card-text" style={{ fontSize: "1.05rem" }}>
// //                 {ACADEMIC_PARAGRAPH}
// //               </p>
// //             </Reveal>
// //           </div>

// //           <motion.div
// //             className="ga-grid ga-grid-3 ga-mt-2"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {ACADEMIC_CARDS.map((card) => (
// //               <Reveal as={motion.div} key={card.title} variants={revealUp} className="ga-card">
// //                 <div className="ga-icon">📘</div>
// //                 <h3 className="ga-card-title">{card.title}</h3>
// //                 <p className="ga-card-text">{card.text}</p>
// //               </Reveal>
// //             ))}
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* 05 — FUTURE-READY LEARNING */}
// //       <section id="ga-future" className="ga-section ga-section--plain">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Future-Ready Learning"
// //             sub="Advanced Education for a Changing World"
// //           />

// //           <motion.div
// //             className="ga-grid ga-grid-4"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {FUTURE_CARDS.map((card) => (
// //               <Reveal as={motion.div} key={card.title} variants={zoomIn} className="ga-card">
// //                 <Placeholder size="medium" />
// //                 <h3 className="ga-card-title" style={{ marginTop: "1rem" }}>
// //                   {card.title}
// //                 </h3>
// //                 <p className="ga-card-text">{card.text}</p>
// //               </Reveal>
// //             ))}
// //           </motion.div>

// //           <Reveal as={motion.div} variants={revealUp} className="ga-statement">
// //             {FUTURE_STATEMENT}
// //           </Reveal>
// //         </div>
// //       </section>

// //       {/* 06 — SPORTS EXCELLENCE */}
// //       <section id="ga-sports" className="ga-section ga-section--alt">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Sports Excellence"
// //             sub="From the Playground to the Podium"
// //           />

// //           <Placeholder size="feature" caption="Large sports photograph (background / feature image)" />

// //           <div className="ga-center">
// //             <div className="ga-levels">
// //               {SPORT_LEVELS.map((level, index) => (
// //                 <React.Fragment key={level}>
// //                   <span className="ga-chip">{level}</span>
// //                   {index < SPORT_LEVELS.length - 1 ? (
// //                     <span className="ga-level-arrow" aria-hidden="true">
// //                       →
// //                     </span>
// //                   ) : null}
// //                 </React.Fragment>
// //               ))}
// //             </div>
// //             <p className="ga-sub" style={{ margin: "0 auto 2rem" }}>
// //               {SPORTS_TEXT}
// //             </p>
// //           </div>

// //           <motion.div
// //             className="ga-grid ga-grid-3"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {SPORTS_GROUPS.map((group) => (
// //               <Reveal as={motion.div} key={group.title} variants={revealUp} className="ga-card">
// //                 <div className="ga-icon">{group.icon}</div>
// //                 <h3 className="ga-card-title">{group.title}</h3>
// //                 <div className="ga-sports-list">
// //                   {group.items.map((item) => (
// //                     <span className="ga-chip" key={item}>
// //                       {item}
// //                     </span>
// //                   ))}
// //                 </div>
// //               </Reveal>
// //             ))}
// //           </motion.div>

// //           <div className="ga-center ga-mt-2" style={{ display: "flex", flexWrap: "wrap", gap: "0.7rem", justifyContent: "center" }}>
// //             {SPORTS_HIGHLIGHT.map((item) => (
// //               <span className="ga-chip" key={item}>
// //                 ✦ {item}
// //               </span>
// //             ))}
// //           </div>

// //           <motion.div
// //             className="ga-mosaic ga-mt-2"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {SPORT_PHOTOS.map((photo) => (
// //               <Reveal
// //                 as={motion.div}
// //                 key={photo.label}
// //                 variants={zoomIn}
// //                 className={photo.wide ? "ga-tile--wide" : undefined}
// //               >
// //                 <PhotoTile label={photo.label} />
// //               </Reveal>
// //             ))}
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* 07 — BEYOND ACADEMICS */}
// //       <section id="ga-beyond" className="ga-section ga-section--plain">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Beyond Academics"
// //             sub="Every Child Has a Talent. Give It a Platform."
// //           />

// //           <motion.div
// //             className="ga-grid ga-grid-6"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {BEYOND_CARDS.map((card) => (
// //               <Reveal as={motion.div} key={card.title} variants={zoomIn} className="ga-card ga-center">
// //                 <div className="ga-icon" style={{ margin: "0 auto 1rem" }}>
// //                   {card.icon}
// //                 </div>
// //                 <h3 className="ga-card-title" style={{ fontSize: "1.05rem" }}>
// //                   {card.title}
// //                 </h3>
// //               </Reveal>
// //             ))}
// //           </motion.div>

// //           <Reveal as={motion.p} variants={revealUp} className="ga-sub ga-mt-2">
// //             {BEYOND_TEXT}
// //           </Reveal>

// //           <div className="ga-grid ga-grid-3 ga-mt-2">
// //             <Placeholder size="large" caption="School activity photograph" />
// //             <Placeholder size="large" caption="School activity photograph" />
// //             <Placeholder size="large" caption="School activity photograph" />
// //           </div>
// //         </div>
// //       </section>

// //       {/* 08 — CAMPUS & INFRASTRUCTURE */}
// //       <section id="ga-campus" className="ga-section ga-section--alt">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Campus & Infrastructure"
// //             sub="A Campus Designed for Learning, Activity & Expression"
// //           />

// //           <motion.div
// //             className="ga-grid ga-grid-8"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {GALLERY_ITEMS.map((item) => (
// //               <Reveal as={motion.div} key={item} variants={zoomIn} className="ga-card" style={{ padding: "1rem" }}>
// //                 <Placeholder size="medium" caption={item} />
// //               </Reveal>
// //             ))}
// //           </motion.div>

// //           <Reveal as={motion.p} variants={revealUp} className="ga-sub ga-mt-2">
// //             {CAMPUS_TEXT}
// //           </Reveal>
// //         </div>
// //       </section>

// //       {/* 09 — SPACES FOR EXPRESSION */}
// //       <section id="ga-spaces" className="ga-section ga-section--plain">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Spaces for Expression"
// //             sub="Learn. Perform. Express. Celebrate."
// //           />

// //           <div className="ga-grid ga-grid-2">
// //             {SPACES.map((space) => (
// //               <Reveal as={motion.div} key={space.title} variants={zoomIn} className="ga-card">
// //                 <Placeholder size="large" caption={space.caption} />
// //                 <h3 className="ga-card-title" style={{ marginTop: "1.1rem" }}>
// //                   {space.title}
// //                 </h3>
// //                 <p className="ga-card-text" style={{ fontWeight: 600, marginBottom: "0.25rem" }}>
// //                   For:
// //                 </p>
// //                 <ul className="ga-space-list">
// //                   {space.items.map((item) => (
// //                     <li key={item}>{item}</li>
// //                   ))}
// //                 </ul>
// //               </Reveal>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* 10 — STUDENT CARE */}
// //       <section id="ga-care" className="ga-section ga-section--alt">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Student Care"
// //             sub="More Than a School. A Complete Care Ecosystem."
// //           />

// //           <motion.div
// //             className="ga-grid ga-grid-4"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {CARE_CARDS.map((card) => (
// //               <Reveal as={motion.div} key={card.title} variants={revealUp} className="ga-card">
// //                 <div className="ga-icon">{card.icon}</div>
// //                 <h3 className="ga-card-title">{card.title}</h3>
// //                 <p className="ga-card-text">{card.text}</p>
// //               </Reveal>
// //             ))}
// //           </motion.div>

// //           <Reveal as={motion.div} variants={revealUp} className="ga-statement">
// //             {CARE_MESSAGE}
// //           </Reveal>
// //         </div>
// //       </section>

// //       {/* 11 — THE GURUKUL ADVANTAGE */}
// //       <section id="ga-advantage" className="ga-section ga-section--plain">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="The Gurukul Advantage"
// //             sub="One School. Multiple Dimensions of Growth."
// //           />

// //           <motion.div
// //             className="ga-grid ga-grid-4"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {ADVANTAGE.map((item) => (
// //               <Reveal as={motion.div} key={item.title} variants={zoomIn} className="ga-card">
// //                 <div className="ga-icon">{item.icon}</div>
// //                 <h3
// //                   className="ga-card-title"
// //                   style={{ textTransform: "uppercase", letterSpacing: "0.05em", fontSize: "1.05rem" }}
// //                 >
// //                   {item.title}
// //                 </h3>
// //                 <p className="ga-card-text">{item.text}</p>
// //               </Reveal>
// //             ))}
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* 12 — WHY CHOOSE GURUKUL? */}
// //       <section id="ga-why" className="ga-section ga-section--alt">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Why Choose Gurukul?"
// //             sub="What Parents Look For. What Gurukul Strives to Provide."
// //           />

// //           <motion.div
// //             className="ga-grid ga-grid-2"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {WHY_LIST.map((item, index) => (
// //               <Reveal as={motion.div} key={item} variants={revealUp} className="ga-check">
// //                 <span className="ga-check-mark">✓</span>
// //                 <span className="ga-check-text">{item}</span>
// //               </Reveal>
// //             ))}
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* 13 — OUR EDUCATIONAL PHILOSOPHY */}
// //       <section id="ga-philosophy" className="ga-section ga-section--plain">
// //         <div className="ga-wrap">
// //           <SectionHead
// //             title="Our Educational Philosophy"
// //             sub="Every Child Has Potential. Our Responsibility Is to Help Them Discover It."
// //           />

// //           <motion.div
// //             className="ga-grid ga-grid-2"
// //             variants={staggerContainer}
// //             initial="hidden"
// //             whileInView="show"
// //             viewport={{ once: true }}
// //           >
// //             {PHILOSOPHY_PARAGRAPHS.map((paragraph) => (
// //               <Reveal as={motion.div} key={paragraph} variants={revealUp} className="ga-card">
// //                 <p className="ga-card-text" style={{ fontSize: "1.05rem" }}>
// //                   {paragraph}
// //                 </p>
// //               </Reveal>
// //             ))}
// //           </motion.div>

// //           <Reveal as={motion.div} variants={zoomIn} className="ga-percent ga-mt-2">
// //             <div style={{ fontSize: "clamp(1.3rem, 3vw, 2rem)", fontWeight: 700, lineHeight: 1.4 }}>
// //               {PHILOSOPHY_STATEMENT}
// //             </div>
// //           </Reveal>
// //         </div>
// //       </section>

// //       {/* 14 — FINAL ADMISSION CTA */}
// //       <section id="ga-admission" className="ga-section ga-final">
// //         <div className="ga-wrap">
// //           <Placeholder size="hero" caption="Campus / student image" />

// //           <h2 className="ga-final-title">
// //             {"Give Your Child the Right Environment to Learn, Grow & Excel."}
// //           </h2>
// //           <p className="ga-final-school">
// //             {"Gurukul English Medium School & Junior College, Abdul Lat"}
// //           </p>
// //           <span className="ga-badge">Nursery to Grade 12</span>

// //           <div className="ga-actions" style={{ justifyContent: "center" }}>
// //             <button className="ga-btn ga-btn-light" onClick={() => goTo("admission-inquiry")}>
// //               Enquire for Admission
// //             </button>
// //             <button className="ga-btn ga-btn-ghost" onClick={() => goTo("unit-contact")}>
// //               Book a Campus Visit
// //             </button>
// //           </div>

// //           <p className="ga-tagline">{"Growing with Trust. Inspiring Excellence."}</p>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default EnglishAcademyShowcase;


// import React, { useEffect, useState } from "react";

// import { motion } from "framer-motion";

// import { Reveal, staggerContainer, revealUp, zoomIn } from "../common/Reveal";

// import { useTheme } from "../../context/ThemeContext";



// /* ------------------------------------------------------------------ *

//  * Content taken from: "web page Gurukul English Medium School.docx"

//  * Recommended Webpage Structure — Gurukul English Medium School &

//  * Junior College, Abdul Lat

//  * Every line of copy of the document is rendered below. Image areas

//  * are left blank and marked with a border (placeholders).

//  * ------------------------------------------------------------------ */



// const HERO_LEAD =

//   "Established in 2008, Gurukul English Medium School & Junior College, Abdul Lat provides a complete Nursery to Grade 12 educational journey that combines academic excellence, advanced learning, sports, values and holistic development.";



// const HERO_CHIPS = [

//   "18+ Years",

//   "770+ Students",

//   "Nursery–12",

//   "100% Board Results*",

// ];



// const HERO_NOTE = "*100% SSC & HSC results consecutively for the last 10 years.";



// const GLANCE = [

//   { value: 18, suffix: "+", label: "Years of Journey" },

//   { value: 770, suffix: "+", label: "Students" },

//   { value: 2008, suffix: "", label: "Established" },

//   { text: "Nursery–12", label: "Complete Schooling" },

//   { value: 10, suffix: " Years", label: "100% SSC & HSC Results" },

// ];



// const TIMELINE = [

//   {

//     year: "2008",

//     text:

//       "Gurukul English Medium School & Junior College begins its journey with 54 students.",

//   },

//   {

//     year: "Growth & Expansion",

//     text:

//       "The institution steadily expands its academic programmes, infrastructure, technology and student opportunities.",

//   },

//   {

//     year: "Today",

//     text:

//       "770+ students from Nursery to Grade 12, supported by a comprehensive educational ecosystem.",

//   },

// ];



// const JOURNEY_TEXT =

//   "What began with 54 students has grown into a thriving K–12 institution through the trust of parents, dedication of teachers and a continuous commitment to educational excellence.";



// const ACADEMIC_PARAGRAPH =

//   "Our academic approach combines concept-based teaching, regular assessment, individual attention, doubt-solving, remedial support and structured examination preparation. Our focus extends beyond examination results to developing knowledge, confidence, discipline and strong learning habits.";



// const ACADEMIC_CARDS = [

//   {

//     title: "Conceptual Learning",

//     text: "Strong understanding rather than rote learning.",

//   },

//   {

//     title: "Individual Attention",

//     text: "Monitoring and support according to student needs.",

//   },

//   {

//     title: "Examination Readiness",

//     text: "Systematic preparation and continuous assessment.",

//   },

// ];



// const FUTURE_CARDS = [

//   {

//     title: "Digital Classrooms",

//     text: "Interactive technology-enabled learning.",

//   },

//   {

//     title: "Robotics Lab",

//     text: "Exploration of robotics, automation and problem-solving.",

//   },

//   {

//     title: "Advanced STEM Labs",

//     text: "Hands-on Science, Technology, Engineering and Mathematics.",

//   },

//   {

//     title: "Computer Labs",

//     text: "Modern computing facilities for digital literacy and technology skills.",

//   },

// ];



// const FUTURE_STATEMENT =

//   "We believe today's education must prepare students not only for today's opportunities, but for a rapidly changing future.";



// const SPORT_LEVELS = ["Taluka", "District", "State", "National"];



// const SPORTS_TEXT =

//   "Our students have achieved success in school sports competitions from Taluka to National level.";



// const SPORTS_GROUPS = [

//   {

//     title: "Combat & Fitness",

//     icon: "dumbbell",

//     items: [

//       "Boxing",

//       "Taekwondo",

//       "Karate",

//       "Yoga",

//       "Zumba",

//       "Lathi-Kathi",

//       "Fencing",

//     ],

//   },

//   {

//     title: "Team & Outdoor Sports",

//     icon: "trophy",

//     items: [

//       "Kho-Kho",

//       "Kabaddi",

//       "Volleyball",

//       "Football",

//       "Throwball",

//       "Cricket",

//     ],

//   },

//   {

//     title: "Indoor",

//     icon: "table-tennis",

//     items: ["Table Tennis", "Other indoor activities"],

//   },

// ];



// const SPORTS_HIGHLIGHT = [

//   "Dedicated coaches",

//   "Large playground",

//   "Regular training",

//   "Competitive opportunities",

// ];



// const SPORT_PHOTOS = [

//   { label: "Boxing", wide: true },

//   { label: "Kho-Kho" },

//   { label: "Cricket" },

//   { label: "Yoga" },

//   { label: "Volleyball" },

//   { label: "Table Tennis", wide: true },

// ];



// const BEYOND_CARDS = [

//   { title: "Creativity", icon: "palette" },

//   { title: "Communication", icon: "messages" },

//   { title: "Confidence", icon: "target" },

//   { title: "Teamwork", icon: "users" },

//   { title: "Self-Expression", icon: "mic" },

//   { title: "Discipline", icon: "shield-check" },

// ];



// const BEYOND_TEXT =

//   "Our co-curricular opportunities encourage students to explore their interests, discover their strengths and develop skills that extend beyond the classroom.";



// const GALLERY_ITEMS = [

//   "Main Campus",

//   "Digital Classroom",

//   "Robotics Lab",

//   "STEM Lab",

//   "Computer Lab",

//   "Playground",

//   "Multipurpose Hall",

//   "Amphitheatre",

// ];



// const CAMPUS_TEXT =

//   "A picturesque campus with modern educational infrastructure provides students with dedicated spaces to learn, experiment, play, perform and grow.";



// const SPACES = [

//   {

//     title: "Multipurpose Hall",

//     caption: "Multipurpose Hall image",

//     items: [

//       "Seminars",

//       "Workshops",

//       "Indoor programmes",

//       "Parent meetings",

//       "Cultural activities",

//       "Student presentations",

//     ],

//   },

//   {

//     title: "Outdoor Amphitheatre",

//     caption: "Outdoor Amphitheatre image",

//     items: [

//       "Cultural programmes",

//       "Performances",

//       "Celebrations",

//       "Student presentations",

//       "School gatherings",

//     ],

//   },

// ];



// const CARE_CARDS = [

//   {

//     icon: "bus",

//     title: "Safe Transportation",

//     text:

//       "Safe and secure school bus facility for students travelling to and from campus.",

//   },

//   {

//     icon: "house",

//     title: "Residential Facilities",

//     text:

//       "Separate hostel facilities for boys and girls in a structured and supportive environment.",

//   },

//   {

//     icon: "sun",

//     title: "Day Boarding",

//     text:

//       "A convenient option for students spending an extended day on campus.",

//   },

//   {

//     icon: "utensils",

//     title: "Meals & Snacks",

//     text: "Nutritious meals and snacks for day-boarder students.",

//   },

// ];



// const CARE_MESSAGE =

//   "We understand that parents want their children to be not only well educated, but also safe, comfortable, cared for and supported throughout the school day.";



// const ADVANTAGE = [

//   { icon: "book-open", title: "Academics", text: "Strong foundations & consistent results" },

//   { icon: "cpu", title: "Technology", text: "Digital • Robotics • STEM • Computing" },

//   { icon: "trophy", title: "Sports", text: "Dedicated coaching & competitive opportunities" },

//   { icon: "palette", title: "Co-Curricular", text: "Creativity • Communication • Confidence" },

//   { icon: "building", title: "Infrastructure", text: "Modern classrooms, labs & activity spaces" },

//   { icon: "heart-handshake", title: "Student Care", text: "Transport • Day Boarding • Meals" },

//   { icon: "house", title: "Residential", text: "Separate boys' & girls' hostel facilities" },

//   { icon: "shield-check", title: "Values", text: "Indian culture • Discipline • Character" },

// ];



// const WHY_LIST = [

//   "18+ Years of Educational Journey",

//   "770+ Students",

//   "Nursery to Grade 12",

//   "10 Consecutive Years of 100% SSC & HSC Results",

//   "Advanced Digital, Robotics & STEM Learning",

//   "Taluka to National-Level Sports Achievements",

//   "Dedicated Sports Coaches",

//   "Wide Range of Co-Curricular Activities",

//   "Modern Infrastructure",

//   "Safe & Secure Transportation",

//   "Separate Boys' & Girls' Hostels",

//   "Day Boarding with Meals & Snacks",

//   "Indian Values & Discipline",

// ];



// const PHILOSOPHY_PARAGRAPHS = [

//   "At Gurukul, we recognise that every child is unique. Some shine in academics, some in sports, technology, creativity or performance.",

//   "Our role is to provide the environment, guidance, opportunities and encouragement that help each child discover their strengths and pursue excellence.",

// ];



// const PHILOSOPHY_STATEMENT =

//   "We prepare students not only for examinations, but for the opportunities and responsibilities of life.";



// /* ------------------------------------------------------------------ */



// const Counter = ({ value, suffix = "", duration = 1600 }) => {

//   const [count, setCount] = useState(0);

//   const [started, setStarted] = useState(false);

//   const anchorRef = React.useRef(null);



//   useEffect(() => {

//     const el = anchorRef.current;

//     if (!el || started) return undefined;

//     const observer = new IntersectionObserver(

//       (entries) => {

//         if (entries[0].isIntersecting) {

//           setStarted(true);

//           observer.disconnect();

//         }

//       },

//       { threshold: 0.2 }

//     );

//     observer.observe(el);

//     return () => observer.disconnect();

//   }, [started]);



//   useEffect(() => {

//     if (!started) return undefined;

//     let frame;

//     const startTime = performance.now();

//     const tick = (now) => {

//       const p = Math.min((now - startTime) / duration, 1);

//       const eased = 1 - Math.pow(1 - p, 3);

//       setCount(Math.round(value * eased));

//       if (p < 1) frame = requestAnimationFrame(tick);

//     };

//     frame = requestAnimationFrame(tick);

//     return () => cancelAnimationFrame(frame);

//   }, [started, value, duration]);



//   return (

//     <span ref={anchorRef}>

//       {count}

//       {suffix}

//     </span>

//   );

// };



// // Blank, bordered area reserved for an image.

// // size: hero | feature | large | medium | small  (responsive heights)

// const IconGlyph = ({ name, size = 25 }) => {
//   const common = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };
//   const paths = {
//     palette: <><path d="M12 3a9 9 0 1 0 0 18h1.2a1.8 1.8 0 0 0 1.3-3.1 1.8 1.8 0 0 1 1.3-3.1H18a3 3 0 0 0 3-3C21 7.1 17 3 12 3Z"/><circle cx="7.5" cy="10" r="1"/><circle cx="10" cy="6.8" r="1"/><circle cx="15" cy="7.5" r="1"/></>,
//     messages: <><path d="M21 11.5a7.5 7.5 0 0 1-7.5 7.5H7l-4 2v-5.5A7.5 7.5 0 1 1 21 11.5Z"/><path d="M8 10h7M8 13h5"/></>,
//     target: <><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/></>,
//     users: <><path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="10" cy="7" r="4"/><path d="M20 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></>,
//     mic: <><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8"/></>,
//     "shield-check": <><path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z"/><path d="m9 12 2 2 4-4"/></>,
//     dumbbell: <><path d="m6.5 6.5 11 11M4 9l5-5M15 20l5-5M2 7l5-5M17 22l5-5M3 10l7-7M14 21l7-7"/></>,
//     trophy: <><path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4ZM7 6H4v2a4 4 0 0 0 4 4M17 6h3v2a4 4 0 0 1-4 4"/></>,
//     "table-tennis": <><circle cx="15" cy="8" r="5"/><path d="m12 11-8 8M4 19l-1 3 3-1 8-8"/><circle cx="6" cy="5" r="1"/></>,
//     bus: <><path d="M5 17h14M5 6l1-3h12l1 3M4 6h16v11H4zM7 17v3M17 17v3"/><circle cx="7.5" cy="13" r="1"/><circle cx="16.5" cy="13" r="1"/><path d="M7 8h10"/></>,
//     house: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z"/><path d="M9 21v-7h6v7"/></>,
//     sun: <><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42m11.3 11.3 1.42 1.42M2 12h2m16 0h2M4.93 19.07l1.42-1.42m11.3-11.3 1.42-1.42"/></>,
//     utensils: <><path d="M3 2v7a4 4 0 0 0 4 4h1M7 2v20M3 2v5M11 2v5a4 4 0 0 1-4 4M17 2v20M17 2c4 4 4 8 0 10"/></>,
//     "book-open": <><path d="M2 4.5A2.5 2.5 0 0 1 4.5 2H12v19H4.5A2.5 2.5 0 0 0 2 23ZM22 4.5A2.5 2.5 0 0 0 19.5 2H12v19h7.5A2.5 2.5 0 0 1 22 23Z"/></>,
//     cpu: <><rect x="5" y="5" width="14" height="14" rx="2"/><rect x="9" y="9" width="6" height="6"/><path d="M9 1v4m6-4v4M9 19v4m6-4v4M1 9h4m-4 6h4m14-6h4m-4 6h4"/></>,
//     building: <><rect x="4" y="2" width="16" height="20" rx="1"/><path d="M9 22v-4h6v4M8 6h2m4 0h2M8 10h2m4 0h2M8 14h2m4 0h2"/></>,
//     "heart-handshake": <><path d="M20.8 8.5c0 5-8.8 10.5-8.8 10.5S3.2 13.5 3.2 8.5A4.5 4.5 0 0 1 12 6.4a4.5 4.5 0 0 1 8.8 2.1Z"/><path d="m8 12 2 2 2-1 2 2 3-3"/></>,
//     "lightbulb": <><path d="M9 18h6M10 22h4M8 14a6 6 0 1 1 8 0c-1 .8-1.5 1.8-1.5 4h-5c0-2.2-.5-3.2-1.5-4Z"/></>,
//     "user-round": <><circle cx="12" cy="8" r="5"/><path d="M3 22a9 9 0 0 1 18 0"/></>,
//     "check-circle": <><circle cx="12" cy="12" r="9"/><path d="m8 12 2.5 2.5L16 9"/></>,
//   };
//   return <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" {...common}>{paths[name] || paths["lightbulb"]}</svg>;
// };

// const Placeholder = ({ size = "medium", caption, radius = "1rem" }) => (

//   <div style={{ width: "100%" }}>

//     <div

//       role="img"

//       aria-label={caption ? `Image placeholder: ${caption}` : "Image placeholder"}

//       className={`ga-ph ga-ph--${size}`}

//       style={{ borderRadius: radius }}

//     />

//     {caption ? <div className="ga-ph-caption">{caption}</div> : null}

//   </div>

// );



// // Image tile with a label bar — used for the sports photo grid.

// const PhotoTile = ({ label }) => (

//   <div className="ga-tile">

//     <div

//       role="img"

//       aria-label={`Image placeholder: ${label}`}

//       className="ga-ph ga-ph--medium"

//     />

//     <span className="ga-tile-label">{label}</span>

//   </div>

// );



// const SectionHead = ({ title, sub }) => (

//   <motion.div

//     className="ga-head"

//     variants={staggerContainer}

//     initial="hidden"

//     whileInView="show"

//     viewport={{ once: true }}

//   >

//     <Reveal as={motion.h2} variants={revealUp} className="ga-title">

//       {title}

//     </Reveal>

//     {sub ? (

//       <Reveal as={motion.p} variants={revealUp} className="ga-sub">

//         {sub}

//       </Reveal>

//     ) : null}

//   </motion.div>

// );



// const EnglishAcademyShowcase = () => {

//   const { colors } = useTheme();



//   const goTo = (id) => {

//     const el = document.getElementById(id);

//     if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });

//   };



//   const rootStyle = {

//     "--ga-primary": colors.primary,

//     "--ga-primary-dark": colors.primaryDark,
//     "--ga-secondary": colors.secondary,
//     "--ga-text-light": colors.textLight,
//     "--ga-hover": colors.hover,
//     "--ga-overlay": colors.overlay,
//     "--ga-button-primary": colors.buttonPrimary,
//     "--ga-button-text": colors.buttonText,

//     "--ga-text": colors.text,

//     "--ga-text2": colors.textSecondary,

//     "--ga-bg": colors.background,

//     "--ga-bg-alt": colors.backgroundAlt,

//     "--ga-card": colors.card,

//     "--ga-border": colors.border,

//     "--ga-shadow": colors.cardShadow,

//   };



//   return (

//     <div className="ga-root" style={rootStyle}>

//       <style>{`

//         .ga-root { position: relative; color: var(--ga-text); font-family: inherit; }

//         .ga-section { padding: 4.5rem 1.5rem; scroll-margin-top: 116px; position: relative; }

//         .ga-section--alt { background: var(--ga-bg-alt); }

//         .ga-section--plain { background: var(--ga-bg); }

//         .ga-wrap { max-width: 1200px; margin: 0 auto; }



//         .ga-head { text-align: center; margin-bottom: 2.75rem; }

//         .ga-title {

//           font-size: clamp(1.75rem, 3.6vw, 2.6rem); font-weight: 700;

//           line-height: 1.2; margin: 0 0 0.6rem; color: var(--ga-text);

//         }

//         .ga-sub { font-size: 1.08rem; color: var(--ga-text2); max-width: 840px; margin: 0 auto; }



//         .ga-card {

//           background: var(--ga-card); border: 1px solid var(--ga-border);

//           border-radius: 1.1rem; padding: 1.6rem; box-shadow: var(--ga-shadow);

//           transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;

//         }

//         .ga-card:hover {

//           transform: translateY(-6px); border-color: var(--ga-primary);

//           box-shadow: 0 16px 32px color-mix(in srgb, var(--ga-primary) 16%, transparent);

//         }

//         .ga-grid { display: grid; gap: 1.5rem; }

//         .ga-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

//         .ga-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

//         .ga-grid-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }

//         .ga-grid-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }

//         .ga-grid-6 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

//         .ga-grid-8 { grid-template-columns: repeat(4, minmax(0, 1fr)); }

//         /* Beyond Academics: continuous left-moving card strip */
//         .ga-beyond-marquee {
//           width: 100%;
//           overflow: hidden;
//           position: relative;
//           padding: 0.35rem 0 0.8rem;
//         }
//         .ga-beyond-track {
//           display: flex;
//           width: max-content;
//           gap: 1.5rem;
//           animation: ga-beyond-scroll 28s linear infinite;
//           will-change: transform;
//         }
//         .ga-beyond-marquee:hover .ga-beyond-track,
//         .ga-beyond-marquee:focus-within .ga-beyond-track {
//           animation-play-state: paused;
//         }
//         .ga-beyond-card {
//           flex: 0 0 clamp(170px, 22vw, 250px);
//           min-height: 130px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }
//         @keyframes ga-beyond-scroll {
//           from { transform: translateX(0); }
//           to { transform: translateX(calc(-50% - 0.75rem)); }
//         }
//         @media (prefers-reduced-motion: reduce) {
//           .ga-beyond-track { animation: none; }
//         }

//         .ga-ph {

//           width: 100%; border: 2px dashed var(--ga-primary); display: block;

//           background-image: repeating-linear-gradient(

//             135deg,

//             color-mix(in srgb, var(--ga-primary) 10%, transparent) 0 10px,

//             transparent 10px 22px

//           );

//         }

//         /* Responsive image sizes — big on desktop, compact on mobile */

//         .ga-ph--hero { height: clamp(300px, 42vw, 560px); }

//         .ga-ph--feature { height: clamp(300px, 40vw, 520px); }

//         .ga-ph--large { height: clamp(260px, 28vw, 420px); }

//         .ga-ph--medium { height: clamp(210px, 19vw, 320px); }

//         .ga-ph--small { height: clamp(180px, 16vw, 260px); }

//         .ga-ph-caption {

//           margin-top: 0.6rem; font-size: 0.85rem; color: var(--ga-text2);

//           text-align: center; font-weight: 500;

//         }



//         /* Sports photo grid */

//         .ga-mosaic { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.25rem; }

//         .ga-tile {

//           position: relative; overflow: hidden; border-radius: 1rem;

//           box-shadow: var(--ga-shadow);

//         }

//         .ga-tile--wide { grid-column: span 2; }

//         .ga-tile .ga-ph {

//           height: clamp(220px, 20vw, 340px);

//           transition: transform .45s ease, border-color .45s ease;

//           background-color: var(--ga-card);

//         }

//         .ga-tile:hover .ga-ph { transform: scale(1.05); border-color: var(--ga-primary-dark); }

//         .ga-tile-label {

//           position: absolute; left: 0; right: 0; bottom: 0;

//           padding: 1.8rem 0.9rem 0.7rem; font-size: 0.92rem; font-weight: 600;

//           color: #ffffff; letter-spacing: 0.02em;

//           background: linear-gradient(to top, color-mix(in srgb, var(--ga-primary-dark) 92%, transparent) 0%, transparent 100%);

//           transform: translateY(4px); transition: transform .35s ease;

//         }

//         .ga-tile:hover .ga-tile-label { transform: translateY(0); }



//         .ga-chip {

//           display: inline-flex; align-items: center; gap: 0.4rem;

//           padding: 0.45rem 1rem; border-radius: 999px; font-size: 0.92rem;

//           font-weight: 600; color: var(--ga-primary-dark);

//           background: color-mix(in srgb, var(--ga-primary) 10%, transparent); border: 1px solid color-mix(in srgb, var(--ga-primary) 35%, transparent);

//           transition: transform .25s ease, background .25s ease;

//         }

//         .ga-chip:hover { transform: translateY(-3px); background: color-mix(in srgb, var(--ga-primary) 18%, transparent); }



//         .ga-btn {

//           display: inline-flex; align-items: center; justify-content: center;

//           gap: 0.5rem; padding: 0.85rem 1.7rem; border-radius: 0.7rem;

//           font-family: inherit; font-size: 1rem; font-weight: 600; cursor: pointer;

//           border: none; transition: transform .25s ease, box-shadow .25s ease, background .25s ease;

//         }

//         .ga-btn:hover { transform: translateY(-3px); }

//         .ga-btn-primary {

//           background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%);

//           color: #fff; box-shadow: 0 10px 20px color-mix(in srgb, var(--ga-primary) 30%, transparent);

//         }

//         .ga-btn-primary:hover { box-shadow: 0 14px 26px color-mix(in srgb, var(--ga-primary) 40%, transparent); }

//         .ga-btn-outline {

//           background: transparent; color: var(--ga-primary-dark);

//           border: 2px solid var(--ga-primary);

//         }

//         .ga-btn-outline:hover { background: color-mix(in srgb, var(--ga-primary) 12%, transparent); }

//         .ga-btn-light { background: #ffffff; color: var(--ga-primary-dark); box-shadow: 0 10px 20px rgba(0,0,0,0.18); }

//         .ga-btn-ghost { background: transparent; color: #ffffff; border: 2px solid rgba(255,255,255,0.85); }

//         .ga-btn-ghost:hover { background: rgba(255,255,255,0.15); }



//         /* Hero */

//         .ga-hero {

//           background: linear-gradient(135deg, var(--ga-primary-dark) 0%, var(--ga-primary) 100%);

//           color: #ffffff; padding-top: 3.5rem; padding-bottom: 3.5rem;

//         }

//         .ga-hero .ga-ph { border-color: rgba(255,255,255,0.8); background-image: repeating-linear-gradient(135deg, rgba(255,255,255,0.12) 0 10px, rgba(255,255,255,0) 10px 22px); }

//         .ga-hero-title {

//           font-size: clamp(2rem, 5vw, 3.4rem); font-weight: 800; line-height: 1.15;

//           margin: 2rem 0 1rem; color: #ffffff;

//         }

//         .ga-hero-lead { font-size: 1.1rem; line-height: 1.7; color: rgba(255,255,255,0.92); max-width: 900px; margin: 0 0 1.6rem; }

//         .ga-hero-chips { display: flex; flex-wrap: wrap; gap: 0.7rem; margin-bottom: 1.8rem; }

//         .ga-hero-chips .ga-chip {

//           background: rgba(255,255,255,0.16); border-color: rgba(255,255,255,0.5); color: #ffffff;

//           font-size: 1rem; padding: 0.55rem 1.1rem;

//         }

//         .ga-hero-chips .ga-chip:hover { background: rgba(255,255,255,0.28); }

//         .ga-actions { display: flex; flex-wrap: wrap; gap: 1rem; margin-bottom: 1.2rem; }

//         .ga-note { font-size: 0.9rem; color: rgba(255,255,255,0.85); margin: 0; }



//         /* Glance */

//         .ga-stat { text-align: center; padding: 1.75rem 1rem; }

//         .ga-stat-value {

//           font-size: clamp(2rem, 4vw, 2.75rem); font-weight: 800;

//           background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%);

//           -webkit-background-clip: text; background-clip: text;

//           -webkit-text-fill-color: transparent; line-height: 1.1;

//         }

//         .ga-stat-label { margin-top: 0.5rem; color: var(--ga-text2); font-size: 0.98rem; }



//         /* Journey */

//         .ga-timeline { display: flex; flex-wrap: wrap; gap: 1rem; align-items: stretch; }

//         .ga-timeline .ga-node { flex: 1 1 260px; }

//         .ga-node { position: relative; text-align: left; }

//         .ga-node-year {

//           display: inline-block; padding: 0.3rem 0.9rem; border-radius: 999px;

//           background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%);

//           color: #fff; font-weight: 700; font-size: 0.95rem; margin-bottom: 0.9rem;

//         }

//         .ga-node-arrow {

//           display: flex; align-items: center; justify-content: center;

//           color: var(--ga-primary); font-size: 1.6rem; font-weight: 700;

//         }

//         .ga-quote {

//           background: var(--ga-card); border-left: 5px solid var(--ga-primary);

//           border-radius: 0.75rem; padding: 1.4rem 1.6rem; color: var(--ga-text);

//           font-size: 1.05rem; line-height: 1.75; box-shadow: var(--ga-shadow);

//         }



//         /* Big 100% visual */

//         .ga-percent {

//           display: flex; flex-direction: column; align-items: center; justify-content: center;

//           text-align: center; padding: 2.5rem 1.5rem; border-radius: 1rem;

//           background: linear-gradient(135deg, var(--ga-primary-dark) 0%, var(--ga-primary) 100%); color: #fff;

//           box-shadow: 0 18px 36px rgba(3, 105, 161, 0.28);

//         }

//         .ga-percent-number { font-size: clamp(4rem, 10vw, 6rem); font-weight: 800; line-height: 1; }

//         .ga-percent-years { font-size: 1.15rem; font-weight: 600; margin-top: 0.75rem; opacity: 0.95; }

//         .ga-percent-label { font-size: 1.35rem; font-weight: 700; margin-top: 0.35rem; }



//         .ga-icon {

//           width: 52px; height: 52px; border-radius: 0.9rem; display: flex;

//           align-items: center; justify-content: center; font-size: 1.5rem;

//           background: color-mix(in srgb, var(--ga-primary) 12%, transparent); border: 1px solid color-mix(in srgb, var(--ga-primary) 30%, transparent);

//           margin-bottom: 1rem;

//         }

//         .ga-icon { position: relative; }
//         .ga-icon::before {
//           content: ""; display: block; width: 18px; height: 18px;
//           border: 2px solid var(--ga-primary); border-radius: 5px;
//           transform: rotate(45deg); opacity: 0.9;
//         }
//         .ga-card-title { font-size: 1.2rem; font-weight: 700; color: var(--ga-text); margin: 0 0 0.5rem; }

//         .ga-card-text { color: var(--ga-text2); margin: 0; line-height: 1.65; }



//         .ga-statement {

//           margin-top: 2rem; text-align: center; padding: 1.6rem 1.8rem;

//           border-radius: 1rem; font-size: 1.12rem; line-height: 1.7; font-weight: 500;

//           background: color-mix(in srgb, var(--ga-primary) 10%, transparent); border: 1px solid color-mix(in srgb, var(--ga-primary) 35%, transparent);

//           color: var(--ga-text);

//         }



//         .ga-levels { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 0.6rem; margin: 1.5rem 0; }

//         .ga-level-arrow { color: var(--ga-primary); font-weight: 800; font-size: 1.2rem; }

//         .ga-sports-list { display: flex; flex-wrap: wrap; gap: 0.55rem; margin-top: 1rem; }

//         .ga-sports-list .ga-chip { cursor: default; }



//         .ga-check {

//           display: flex; align-items: flex-start; gap: 0.75rem; padding: 0.85rem 1rem;

//           border-radius: 0.75rem; background: var(--ga-card); border: 1px solid var(--ga-border);

//           transition: transform .25s ease, border-color .25s ease, box-shadow .25s ease;

//         }

//         .ga-check:hover { transform: translateX(6px); border-color: var(--ga-primary); box-shadow: 0 10px 20px color-mix(in srgb, var(--ga-primary) 12%, transparent); }

//         .ga-check-mark {

//           flex: 0 0 auto; width: 26px; height: 26px; border-radius: 50%;

//           display: flex; align-items: center; justify-content: center;

//           background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%);

//           color: #fff; font-size: 0.85rem; font-weight: 700;

//         }

//         .ga-check-text { color: var(--ga-text); font-weight: 500; line-height: 1.5; }



//         .ga-space-list { list-style: none; padding: 0; margin: 1rem 0 0; display: grid; gap: 0.5rem; }

//         .ga-space-list li { display: flex; gap: 0.6rem; align-items: center; color: var(--ga-text2); }

//         .ga-space-list li::before { content: "▸"; color: var(--ga-primary); font-weight: 700; }



//         .ga-final {

//           background: linear-gradient(135deg, var(--ga-primary-dark) 0%, var(--ga-primary) 100%);

//           color: #fff; text-align: center;

//         }

//         .ga-final .ga-ph { border-color: rgba(255,255,255,0.8); background-image: repeating-linear-gradient(135deg, rgba(255,255,255,0.12) 0 10px, rgba(255,255,255,0) 10px 22px); }

//         .ga-final .ga-ph-caption { color: rgba(255,255,255,0.85); }

//         .ga-final-title { font-size: clamp(1.8rem, 4vw, 2.8rem); font-weight: 800; line-height: 1.2; margin: 2rem 0 1rem; color: #fff; }

//         .ga-final-school { font-size: 1.15rem; font-weight: 600; color: rgba(255,255,255,0.95); margin: 0 0 0.6rem; }

//         .ga-badge {

//           display: inline-block; padding: 0.4rem 1.1rem; border-radius: 999px;

//           background: rgba(255,255,255,0.18); border: 1px solid rgba(255,255,255,0.5);

//           font-weight: 600; margin-bottom: 1.6rem;

//         }

//         .ga-tagline { margin-top: 1.5rem; font-size: 1.1rem; font-style: italic; color: rgba(255,255,255,0.92); }



//         .ga-center { text-align: center; }

//         .ga-mt-2 { margin-top: 2rem; }

//         .ga-mb-1 { margin-bottom: 1rem; }



//         @media (min-width: 1025px) {

//           .ga-mosaic { grid-template-columns: repeat(4, 1fr); }

//         }



//         @media (max-width: 1024px) {

//           .ga-grid { gap: 1.25rem; }

//           .ga-grid-3, .ga-grid-4 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

//           .ga-grid-5 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

//           .ga-grid-5 > :last-child { grid-column: span 2; }

//           .ga-grid-8 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

//         }



//         @media (max-width: 768px) {

//           .ga-section { padding: 3rem 1.1rem; scroll-margin-top: 100px; }

//           .ga-head { margin-bottom: 2rem; }

//           .ga-grid { gap: 1rem; }

//           .ga-grid-2, .ga-grid-6, .ga-grid-8 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

//           .ga-node-arrow { transform: rotate(90deg); }

//           .ga-mosaic { gap: 1rem; }

//           .ga-ph--hero { height: 240px; }

//           .ga-ph--feature { height: 240px; }

//           .ga-ph--large { height: 210px; }

//           .ga-ph--medium { height: 190px; }

//           .ga-ph--small { height: 160px; }

//           .ga-tile .ga-ph { height: 180px; }

//           .ga-tile--wide .ga-ph { height: 210px; }

//           .ga-actions { gap: 0.75rem; }

//           .ga-actions .ga-btn { flex: 1 1 220px; }

//         }



//         @media (max-width: 560px) {

//           .ga-grid-2, .ga-grid-3, .ga-grid-4 { grid-template-columns: minmax(0, 1fr); }

//           .ga-grid-5 > :last-child { grid-column: span 1; }

//           .ga-stat-value { font-size: 1.7rem; }

//           .ga-percent { padding: 2rem 1rem; }

//         }

//         /* Refined editorial styling using the active ThemeContext palette. */
//         .ga-root { isolation: isolate; }
//         .ga-section--alt { background: var(--ga-bg-alt); }
//         .ga-section--plain { background: var(--ga-bg); }
//         .ga-wrap { max-width: 1240px; }
//         .ga-title { letter-spacing: -0.035em; font-weight: 800; position: relative; display: inline-block; padding-bottom: .8rem; }
//         .ga-title::after { content: ""; position: absolute; width: 56px; height: 4px; left: 50%; bottom: 0; transform: translateX(-50%); border-radius: 99px; background: var(--ga-primary); }
//         .ga-sub { color: var(--ga-text2); line-height: 1.75; }
//         .ga-card { background: var(--ga-card); border: 1px solid var(--ga-border); border-radius: 1.25rem; padding: 1.7rem; box-shadow: var(--ga-shadow); }
//         .ga-card:hover { transform: translateY(-5px); border-color: var(--ga-primary); box-shadow: 0 16px 32px color-mix(in srgb, var(--ga-primary) 18%, transparent); }
//         .ga-ph { border: 1px solid var(--ga-border); background-color: var(--ga-bg-alt); background-image: linear-gradient(135deg, color-mix(in srgb, var(--ga-primary) 8%, transparent), transparent), repeating-linear-gradient(135deg, color-mix(in srgb, var(--ga-text) 3%, transparent) 0 12px, transparent 12px 26px); }
//         .ga-ph-caption { color: var(--ga-text2); }
//         .ga-tile { border-radius: 1.25rem; box-shadow: var(--ga-shadow); }
//         .ga-tile-label { background: linear-gradient(to top, color-mix(in srgb, var(--ga-bg) 96%, transparent) 0%, transparent 100%); }
//         .ga-chip { background: var(--ga-card); border: 1px solid var(--ga-border); color: var(--ga-text); box-shadow: var(--ga-shadow); }
//         .ga-chip:hover { background: var(--ga-hover, var(--ga-bg-alt)); }
//         .ga-btn { border-radius: .65rem; letter-spacing: .005em; }
//         .ga-btn-primary { background: var(--ga-primary); color: var(--ga-button-text, #fff); box-shadow: 0 9px 20px color-mix(in srgb, var(--ga-primary) 24%, transparent); }
//         .ga-btn-primary:hover { box-shadow: 0 12px 24px color-mix(in srgb, var(--ga-primary) 32%, transparent); }
//         .ga-btn-outline { color: var(--ga-primary); border-color: var(--ga-primary); }
//         .ga-btn-outline:hover { background: color-mix(in srgb, var(--ga-primary) 12%, transparent); }
//         .ga-btn-light { color: var(--ga-primary-dark); background: var(--ga-card); }
//         .ga-btn-ghost { color: var(--ga-text); border-color: color-mix(in srgb, var(--ga-text) 35%, transparent); }
//         .ga-hero { color: var(--ga-text); overflow: hidden; background: linear-gradient(118deg, var(--ga-bg) 0%, var(--ga-bg-alt) 100%); padding-top: 4rem; padding-bottom: 4rem; position: relative; }
//         .ga-hero::before, .ga-final::before { content: ""; position: absolute; width: 340px; height: 340px; right: -110px; top: -145px; border: 1px solid color-mix(in srgb, var(--ga-primary) 22%, transparent); border-radius: 50%; box-shadow: 0 0 0 34px color-mix(in srgb, var(--ga-primary) 5%, transparent), 0 0 0 70px color-mix(in srgb, var(--ga-primary) 4%, transparent); pointer-events: none; }
//         .ga-hero .ga-wrap, .ga-final .ga-wrap { position: relative; z-index: 1; }
//         .ga-hero .ga-ph, .ga-final .ga-ph { border-color: color-mix(in srgb, var(--ga-border) 80%, transparent); background-color: color-mix(in srgb, var(--ga-primary) 7%, var(--ga-bg)); box-shadow: var(--ga-shadow); }
//         .ga-hero-title, .ga-final-title { color: var(--ga-text); letter-spacing: -.035em; text-wrap: balance; }
//         .ga-hero-title { max-width: 920px; color: var(--ga-text); }
//         .ga-hero-lead { max-width: 860px; color: var(--ga-text2); }
//         .ga-hero-chips .ga-chip { background: color-mix(in srgb, var(--ga-card) 90%, transparent); border-color: var(--ga-border); color: var(--ga-text); box-shadow: none; backdrop-filter: blur(8px); }
//         .ga-note { color: var(--ga-text2); }
//         .ga-stat { border-top: 3px solid var(--ga-primary); padding-top: 1.55rem; }
//         .ga-stat-value { background: none; color: var(--ga-text); -webkit-text-fill-color: var(--ga-text); letter-spacing: -.04em; }
//         .ga-stat-label { color: var(--ga-text2); line-height: 1.5; }
//         .ga-node-year { background: var(--ga-primary); color: var(--ga-button-text, #fff); border-radius: .45rem; box-shadow: inset 3px 0 0 var(--ga-primary-dark); }
//         .ga-node-arrow { color: var(--ga-primary); }
//         .ga-quote { background: var(--ga-bg-alt); border-left: 4px solid var(--ga-primary); border-radius: .35rem 1rem 1rem .35rem; box-shadow: none; }
//         .ga-percent { background: linear-gradient(120deg, var(--ga-primary-dark) 0%, var(--ga-primary) 100%); border: 1px solid color-mix(in srgb, var(--ga-border) 70%, transparent); border-radius: 1.4rem; box-shadow: var(--ga-shadow); position: relative; overflow: hidden; color: var(--ga-button-text, #fff); }
//         .ga-percent::after { content: ""; position: absolute; width: 180px; height: 180px; right: -50px; bottom: -105px; border: 1px solid color-mix(in srgb, var(--ga-button-text, #fff) 25%, transparent); border-radius: 50%; box-shadow: 0 0 0 20px color-mix(in srgb, var(--ga-button-text, #fff) 5%, transparent), 0 0 0 42px color-mix(in srgb, var(--ga-button-text, #fff) 3%, transparent); pointer-events: none; }
//         .ga-percent-number { color: var(--ga-button-text, #fff); }
//         .ga-icon { color: var(--ga-primary); border-radius: .75rem; background: color-mix(in srgb, var(--ga-primary) 12%, var(--ga-card)); border: 1px solid color-mix(in srgb, var(--ga-primary) 28%, var(--ga-border)); }
//         .ga-icon::before { content: none; }
//         .ga-card-title { color: var(--ga-text); letter-spacing: -.015em; }
//         .ga-card-text { color: var(--ga-text2); }
//         .ga-statement { background: var(--ga-bg-alt); border: 1px solid var(--ga-border); border-left: 4px solid var(--ga-primary); border-radius: .35rem 1rem 1rem .35rem; }
//         .ga-level-arrow { color: var(--ga-primary); }
//         .ga-check { border-color: var(--ga-border); border-radius: .85rem; box-shadow: var(--ga-shadow); }
//         .ga-check:hover { border-color: var(--ga-primary); box-shadow: 0 10px 22px color-mix(in srgb, var(--ga-primary) 12%, transparent); }
//         .ga-check-mark { background: var(--ga-primary); color: var(--ga-button-text, #fff); }
//         .ga-check-text { color: var(--ga-text); }
//         .ga-space-list li::before { content: "✓"; color: var(--ga-primary); }
//         .ga-final { color: var(--ga-text); overflow: hidden; background: linear-gradient(118deg, var(--ga-bg) 0%, var(--ga-bg-alt) 100%); position: relative; }
//         .ga-final .ga-badge { background: var(--ga-bg-alt); border-color: var(--ga-border); }
//         .ga-tagline { color: var(--ga-primary); }
//         .ga-root :focus-visible { outline: 3px solid var(--ga-primary); outline-offset: 3px; }

//         /* Typography follows the site's global font; compact, touch-friendly mobile layout. */
//         .ga-root, .ga-root * { font-family: inherit; }
//         .ga-root { font-size: 1rem; }

//         @media (max-width: 768px) {
//           .ga-section { padding: 2.5rem 1rem; scroll-margin-top: 88px; }
//           .ga-wrap { width: 100%; }
//           .ga-head { margin-bottom: 1.5rem; }
//           .ga-title { font-size: clamp(1.45rem, 4.8vw, 1.8rem); line-height: 1.25; font-weight: 700; letter-spacing: normal; padding-bottom: .6rem; }
//           .ga-title::after { width: 42px; height: 3px; }
//           .ga-sub { font-size: .92rem; line-height: 1.55; }
//           .ga-card { padding: 1.1rem; border-radius: .9rem; }
//           .ga-card-title { font-size: 1rem; line-height: 1.35; letter-spacing: normal; }
//           .ga-card-text { font-size: .9rem; line-height: 1.55; }
//           .ga-hero { padding-top: 2.25rem; padding-bottom: 2.25rem; }
//           .ga-hero-title { font-size: clamp(1.7rem, 6vw, 2.15rem); line-height: 1.2; font-weight: 700; letter-spacing: normal; margin: 1.25rem 0 .75rem; }
//           .ga-hero-lead { font-size: .95rem; line-height: 1.6; margin-bottom: 1.1rem; }
//           .ga-hero-chips { gap: .5rem; margin-bottom: 1.2rem; }
//           .ga-hero-chips .ga-chip { font-size: .82rem; padding: .4rem .7rem; }
//           .ga-grid { gap: .8rem; }
//           .ga-stat { padding: 1rem .7rem; }
//           .ga-stat-value { font-size: clamp(1.35rem, 5vw, 1.7rem); letter-spacing: normal; }
//           .ga-stat-label { font-size: .8rem; line-height: 1.4; }
//           .ga-icon { width: 2.4rem; height: 2.4rem; font-size: 1.15rem; }
//           .ga-actions { gap: .65rem; }
//           .ga-actions .ga-btn { flex: 1 1 100%; min-height: 44px; padding: .75rem 1rem; font-size: .92rem; }
//           .ga-percent { padding: 1.5rem 1rem; border-radius: 1rem; }
//           .ga-percent-number { font-size: clamp(2.8rem, 12vw, 4rem); }
//           .ga-percent-label { font-size: 1.05rem; }
//           .ga-final-title { font-size: clamp(1.55rem, 5.5vw, 2rem); line-height: 1.25; font-weight: 700; letter-spacing: normal; }
//           .ga-final-school { font-size: .95rem; line-height: 1.5; }
//           .ga-beyond-track { gap: .8rem; }
//           .ga-beyond-card { flex-basis: min(68vw, 210px); min-height: 112px; }
//           .ga-hero::before, .ga-final::before { width: 220px; height: 220px; right: -100px; top: -100px; }
//         }

//         @media (max-width: 560px) {
//           .ga-section { padding: 2rem .85rem; }
//           .ga-head { margin-bottom: 1.25rem; }
//           .ga-title { font-size: 1.45rem; }
//           .ga-sub { font-size: .88rem; }
//           .ga-grid-2, .ga-grid-3, .ga-grid-4 { grid-template-columns: minmax(0, 1fr); }
//           .ga-grid-5 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
//           .ga-grid-5 > :last-child { grid-column: span 2; }
//           .ga-card { padding: .95rem; }
//           .ga-hero { padding: 1.75rem .85rem; }
//           .ga-hero-title { font-size: 1.7rem; }
//           .ga-hero-lead { font-size: .9rem; }
//           .ga-ph--hero { height: 175px; }
//           .ga-ph--feature { height: 190px; }
//           .ga-ph--large { height: 170px; }
//           .ga-ph--medium { height: 145px; }
//           .ga-ph--small { height: 125px; }
//           .ga-tile .ga-ph { height: 145px; }
//           .ga-tile--wide .ga-ph { height: 170px; }
//           .ga-check { padding: .75rem; gap: .65rem; }
//           .ga-check-text { font-size: .88rem; line-height: 1.45; }
//           .ga-node-arrow { font-size: 1rem; }
//           .ga-tagline { font-size: .92rem; }
//         }

//         @media (prefers-reduced-motion: reduce) {
//           .ga-beyond-track { animation: none; }
//           .ga-card { transition: none; }
//         }
//       `}</style>



//       {/* 01 — HERO */}

//       <section id="ga-hero" className="ga-section ga-hero">

//         <div className="ga-wrap">

//           <Placeholder size="hero" caption="Full-width photograph / video of the campus with students" />



//           <h1 className="ga-hero-title">

//             {"Strong Foundations. Advanced Learning. Limitless Possibilities."}

//           </h1>

//           <p className="ga-hero-lead">{HERO_LEAD}</p>



//           <div className="ga-hero-chips">

//             {HERO_CHIPS.map((chip) => (

//               <span className="ga-chip" key={chip}>

//                 {chip}

//               </span>

//             ))}

//           </div>



//           <div className="ga-actions">

//             <button className="ga-btn ga-btn-light" onClick={() => goTo("ga-glance")}>

//               Explore Gurukul

//             </button>

//             <button className="ga-btn ga-btn-ghost" onClick={() => goTo("admission-inquiry")}>

//               Admission Enquiry

//             </button>

//           </div>

//           <p className="ga-note">{HERO_NOTE}</p>

//         </div>

//       </section>



//       {/* 02 — SCHOOL AT A GLANCE */}

//       <section id="ga-glance" className="ga-section ga-section--alt">

//         <div className="ga-wrap">

//           <SectionHead

//             title="School at a Glance"

//             sub="This gives parents an immediate understanding of the institution."

//           />

//           <motion.div

//             className="ga-grid ga-grid-5"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {GLANCE.map((stat) => (

//               <Reveal as={motion.div} key={stat.label} variants={zoomIn} className="ga-card ga-stat">

//                 <div className="ga-stat-value">

//                   {stat.text ? stat.text : <Counter value={stat.value} suffix={stat.suffix} />}

//                 </div>

//                 <div className="ga-stat-label">{stat.label}</div>

//               </Reveal>

//             ))}

//           </motion.div>

//         </div>

//       </section>



//       {/* 03 — OUR JOURNEY */}

//       <section id="ga-journey" className="ga-section ga-section--plain">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Our Journey"

//             sub="From 54 Students to 770+ Students"

//           />



//           <div className="ga-timeline">

//             {TIMELINE.map((node, index) => (

//               <React.Fragment key={node.year}>

//                 <Reveal as={motion.div} variants={zoomIn} className="ga-card ga-node">

//                   <span className="ga-node-year">{node.year}</span>

//                   <p className="ga-card-text">{node.text}</p>

//                 </Reveal>

//                 {index < TIMELINE.length - 1 ? (

//                   <div className="ga-node-arrow" aria-hidden="true">

//                     →

//                   </div>

//                 ) : null}

//               </React.Fragment>

//             ))}

//           </div>



//           <Reveal as={motion.div} variants={revealUp} className="ga-quote ga-mt-2">

//             {JOURNEY_TEXT}

//           </Reveal>



//           <div className="ga-grid ga-grid-2 ga-mt-2">

//             <Placeholder size="large" caption="Old photograph" />

//             <Placeholder size="large" caption="Present-day campus photograph" />

//           </div>

//         </div>

//       </section>



//       {/* 04 — ACADEMIC EXCELLENCE */}

//       <section id="ga-academics" className="ga-section ga-section--alt">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Academic Excellence"

//             sub="Strong Foundations. Consistent Results."

//           />



//           <div className="ga-grid ga-grid-2" style={{ alignItems: "stretch" }}>

//             <Reveal as={motion.div} variants={zoomIn}>

//               <div className="ga-percent">

//                 <div className="ga-percent-number">100%</div>

//                 <div className="ga-percent-years">10 Consecutive Years</div>

//                 <div className="ga-percent-label">100% SSC &amp; HSC Board Results</div>

//               </div>

//             </Reveal>

//             <Reveal as={motion.div} variants={revealUp} className="ga-card" style={{ display: "flex", alignItems: "center" }}>

//               <p className="ga-card-text" style={{ fontSize: "1.05rem" }}>

//                 {ACADEMIC_PARAGRAPH}

//               </p>

//             </Reveal>

//           </div>



//           <motion.div

//             className="ga-grid ga-grid-3 ga-mt-2"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {ACADEMIC_CARDS.map((card) => (

//               <Reveal as={motion.div} key={card.title} variants={revealUp} className="ga-card">

//                 <div className="ga-icon" aria-hidden="true"><IconGlyph name={card.title === "Conceptual Learning" ? "book-open" : card.title === "Individual Attention" ? "user-round" : "check-circle"} /></div>

//                 <h3 className="ga-card-title">{card.title}</h3>

//                 <p className="ga-card-text">{card.text}</p>

//               </Reveal>

//             ))}

//           </motion.div>

//         </div>

//       </section>



//       {/* 05 — FUTURE-READY LEARNING */}

//       <section id="ga-future" className="ga-section ga-section--plain">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Future-Ready Learning"

//             sub="Advanced Education for a Changing World"

//           />



//           <motion.div

//             className="ga-grid ga-grid-4"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {FUTURE_CARDS.map((card) => (

//               <Reveal as={motion.div} key={card.title} variants={zoomIn} className="ga-card">

//                 <Placeholder size="medium" />

//                 <h3 className="ga-card-title" style={{ marginTop: "1rem" }}>

//                   {card.title}

//                 </h3>

//                 <p className="ga-card-text">{card.text}</p>

//               </Reveal>

//             ))}

//           </motion.div>



//           <Reveal as={motion.div} variants={revealUp} className="ga-statement">

//             {FUTURE_STATEMENT}

//           </Reveal>

//         </div>

//       </section>



//       {/* 06 — SPORTS EXCELLENCE */}

//       <section id="ga-sports" className="ga-section ga-section--alt">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Sports Excellence"

//             sub="From the Playground to the Podium"

//           />



//           <Placeholder size="feature" caption="Large sports photograph (background / feature image)" />



//           <div className="ga-center">

//             <div className="ga-levels">

//               {SPORT_LEVELS.map((level, index) => (

//                 <React.Fragment key={level}>

//                   <span className="ga-chip">{level}</span>

//                   {index < SPORT_LEVELS.length - 1 ? (

//                     <span className="ga-level-arrow" aria-hidden="true">

//                       →

//                     </span>

//                   ) : null}

//                 </React.Fragment>

//               ))}

//             </div>

//             <p className="ga-sub" style={{ margin: "0 auto 2rem" }}>

//               {SPORTS_TEXT}

//             </p>

//           </div>



//           <motion.div

//             className="ga-grid ga-grid-3"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {SPORTS_GROUPS.map((group) => (

//               <Reveal as={motion.div} key={group.title} variants={revealUp} className="ga-card">

//                 <div className="ga-icon"><IconGlyph name={group.icon} /></div>

//                 <h3 className="ga-card-title">{group.title}</h3>

//                 <div className="ga-sports-list">

//                   {group.items.map((item) => (

//                     <span className="ga-chip" key={item}>

//                       {item}

//                     </span>

//                   ))}

//                 </div>

//               </Reveal>

//             ))}

//           </motion.div>



//           <div className="ga-center ga-mt-2" style={{ display: "flex", flexWrap: "wrap", gap: "0.7rem", justifyContent: "center" }}>

//             {SPORTS_HIGHLIGHT.map((item) => (

//               <span className="ga-chip" key={item}>

//                 {item}

//               </span>

//             ))}

//           </div>



//           <motion.div

//             className="ga-mosaic ga-mt-2"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {SPORT_PHOTOS.map((photo) => (

//               <Reveal

//                 as={motion.div}

//                 key={photo.label}

//                 variants={zoomIn}

//                 className={photo.wide ? "ga-tile--wide" : undefined}

//               >

//                 <PhotoTile label={photo.label} />

//               </Reveal>

//             ))}

//           </motion.div>

//         </div>

//       </section>



//       {/* 07 — BEYOND ACADEMICS */}

//       <section id="ga-beyond" className="ga-section ga-section--plain">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Beyond Academics"

//             sub="Every Child Has a Talent. Give It a Platform."

//           />



//           <div className="ga-beyond-marquee" aria-label="Beyond Academics activities">

//             <div className="ga-beyond-track">

//               {[...BEYOND_CARDS, ...BEYOND_CARDS].map((card, index) => (

//                 <div
//                   className="ga-card ga-center ga-beyond-card"
//                   key={`${card.title}-${index}`}
//                   aria-hidden={index >= BEYOND_CARDS.length ? "true" : undefined}
//                 >

//                   <div className="ga-icon" style={{ margin: "0 auto 1rem" }}>

//                     <IconGlyph name={card.icon} />

//                   </div>

//                   <h3 className="ga-card-title" style={{ fontSize: "1.05rem" }}>

//                     {card.title}

//                   </h3>

//                 </div>

//               ))}

//             </div>

//           </div>



//           <Reveal as={motion.p} variants={revealUp} className="ga-sub ga-mt-2">

//             {BEYOND_TEXT}

//           </Reveal>



//           <div className="ga-grid ga-grid-3 ga-mt-2">

//             <Placeholder size="large" caption="School activity photograph" />

//             <Placeholder size="large" caption="School activity photograph" />

//             <Placeholder size="large" caption="School activity photograph" />

//           </div>

//         </div>

//       </section>



//       {/* 08 — CAMPUS & INFRASTRUCTURE */}

//       <section id="ga-campus" className="ga-section ga-section--alt">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Campus & Infrastructure"

//             sub="A Campus Designed for Learning, Activity & Expression"

//           />



//           <motion.div

//             className="ga-grid ga-grid-8"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {GALLERY_ITEMS.map((item) => (

//               <Reveal as={motion.div} key={item} variants={zoomIn} className="ga-card" style={{ padding: "1rem" }}>

//                 <Placeholder size="medium" caption={item} />

//               </Reveal>

//             ))}

//           </motion.div>



//           <Reveal as={motion.p} variants={revealUp} className="ga-sub ga-mt-2">

//             {CAMPUS_TEXT}

//           </Reveal>

//         </div>

//       </section>



//       {/* 09 — SPACES FOR EXPRESSION */}

//       <section id="ga-spaces" className="ga-section ga-section--plain">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Spaces for Expression"

//             sub="Learn. Perform. Express. Celebrate."

//           />



//           <div className="ga-grid ga-grid-2">

//             {SPACES.map((space) => (

//               <Reveal as={motion.div} key={space.title} variants={zoomIn} className="ga-card">

//                 <Placeholder size="large" caption={space.caption} />

//                 <h3 className="ga-card-title" style={{ marginTop: "1.1rem" }}>

//                   {space.title}

//                 </h3>

//                 <p className="ga-card-text" style={{ fontWeight: 600, marginBottom: "0.25rem" }}>

//                   For:

//                 </p>

//                 <ul className="ga-space-list">

//                   {space.items.map((item) => (

//                     <li key={item}>{item}</li>

//                   ))}

//                 </ul>

//               </Reveal>

//             ))}

//           </div>

//         </div>

//       </section>



//       {/* 10 — STUDENT CARE */}

//       <section id="ga-care" className="ga-section ga-section--alt">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Student Care"

//             sub="More Than a School. A Complete Care Ecosystem."

//           />



//           <motion.div

//             className="ga-grid ga-grid-4"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {CARE_CARDS.map((card) => (

//               <Reveal as={motion.div} key={card.title} variants={revealUp} className="ga-card">

//                 <div className="ga-icon"><IconGlyph name={card.icon} /></div>

//                 <h3 className="ga-card-title">{card.title}</h3>

//                 <p className="ga-card-text">{card.text}</p>

//               </Reveal>

//             ))}

//           </motion.div>



//           <Reveal as={motion.div} variants={revealUp} className="ga-statement">

//             {CARE_MESSAGE}

//           </Reveal>

//         </div>

//       </section>



//       {/* 11 — THE GURUKUL ADVANTAGE */}

//       <section id="ga-advantage" className="ga-section ga-section--plain">

//         <div className="ga-wrap">

//           <SectionHead

//             title="The Gurukul Advantage"

//             sub="One School. Multiple Dimensions of Growth."

//           />



//           <motion.div

//             className="ga-grid ga-grid-4"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {ADVANTAGE.map((item) => (

//               <Reveal as={motion.div} key={item.title} variants={zoomIn} className="ga-card">

//                 <div className="ga-icon"><IconGlyph name={item.icon} /></div>

//                 <h3

//                   className="ga-card-title"

//                   style={{ textTransform: "uppercase", letterSpacing: "0.05em", fontSize: "1.05rem" }}

//                 >

//                   {item.title}

//                 </h3>

//                 <p className="ga-card-text">{item.text}</p>

//               </Reveal>

//             ))}

//           </motion.div>

//         </div>

//       </section>



//       {/* 12 — WHY CHOOSE GURUKUL? */}

//       <section id="ga-why" className="ga-section ga-section--alt">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Why Choose Gurukul?"

//             sub="What Parents Look For. What Gurukul Strives to Provide."

//           />



//           <motion.div

//             className="ga-grid ga-grid-2"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {WHY_LIST.map((item, index) => (

//               <Reveal as={motion.div} key={item} variants={revealUp} className="ga-check">

//                 <span className="ga-check-mark">✓</span>

//                 <span className="ga-check-text">{item}</span>

//               </Reveal>

//             ))}

//           </motion.div>

//         </div>

//       </section>



//       {/* 13 — OUR EDUCATIONAL PHILOSOPHY */}

//       <section id="ga-philosophy" className="ga-section ga-section--plain">

//         <div className="ga-wrap">

//           <SectionHead

//             title="Our Educational Philosophy"

//             sub="Every Child Has Potential. Our Responsibility Is to Help Them Discover It."

//           />



//           <motion.div

//             className="ga-grid ga-grid-2"

//             variants={staggerContainer}

//             initial="hidden"

//             whileInView="show"

//             viewport={{ once: true }}

//           >

//             {PHILOSOPHY_PARAGRAPHS.map((paragraph) => (

//               <Reveal as={motion.div} key={paragraph} variants={revealUp} className="ga-card">

//                 <p className="ga-card-text" style={{ fontSize: "1.05rem" }}>

//                   {paragraph}

//                 </p>

//               </Reveal>

//             ))}

//           </motion.div>



//           <Reveal as={motion.div} variants={zoomIn} className="ga-percent ga-mt-2">

//             <div style={{ fontSize: "clamp(1.3rem, 3vw, 2rem)", fontWeight: 700, lineHeight: 1.4 }}>

//               {PHILOSOPHY_STATEMENT}

//             </div>

//           </Reveal>

//         </div>

//       </section>



//       {/* 14 — FINAL ADMISSION CTA */}

//       <section id="ga-admission" className="ga-section ga-final">

//         <div className="ga-wrap">

//           <Placeholder size="hero" caption="Campus / student image" />



//           <h2 className="ga-final-title">

//             {"Give Your Child the Right Environment to Learn, Grow & Excel."}

//           </h2>

//           <p className="ga-final-school">

//             {"Gurukul English Medium School & Junior College, Abdul Lat"}

//           </p>

//           <span className="ga-badge">Nursery to Grade 12</span>



//           <div className="ga-actions" style={{ justifyContent: "center" }}>

//             <button className="ga-btn ga-btn-light" onClick={() => goTo("admission-inquiry")}>

//               Enquire for Admission

//             </button>

//             <button className="ga-btn ga-btn-ghost" onClick={() => goTo("unit-contact")}>

//               Book a Campus Visit

//             </button>

//           </div>



//           <p className="ga-tagline">{"Growing with Trust. Inspiring Excellence."}</p>

//         </div>

//       </section>

//     </div>

//   );

// };



// export default EnglishAcademyShowcase;




import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";

import { Reveal, staggerContainer, revealUp, zoomIn } from "../common/Reveal";

import { useTheme } from "../../context/ThemeContext";

/* ------------------------------------------------------------------ *

 * Content taken from: "web page Gurukul English Medium School.docx"

 * Recommended Webpage Structure — Gurukul English Medium School &

 * Junior College, Abdul Lat

 * Every line of copy of the document is rendered below. Image areas

 * are left blank and marked with a border (placeholders).

 * ------------------------------------------------------------------ */

const HERO_LEAD =

  "Established in 2008, Gurukul English Medium School & Junior College, Abdul Lat provides a complete Nursery to Grade 12 educational journey that combines academic excellence, advanced learning, sports, values and holistic development.";

const HERO_CHIPS = [

  "18+ Years",

  "770+ Students",

  "Nursery–12",

  "100% Board Results*",

];

const HERO_NOTE = "*100% SSC & HSC results consecutively for the last 10 years.";

const GLANCE = [

  { value: 18, suffix: "+", label: "Years of Journey" },

  { value: 770, suffix: "+", label: "Students" },

  { value: 2008, suffix: "", label: "Established" },

  { text: "Nursery–12", label: "Complete Schooling" },

  { value: 10, suffix: " Years", label: "100% SSC & HSC Results" },

];

const TIMELINE = [

  {

    year: "2008",

    text:

      "Gurukul English Medium School & Junior College begins its journey with 54 students.",

  },

  {

    year: "Growth & Expansion",

    text:

      "The institution steadily expands its academic programmes, infrastructure, technology and student opportunities.",

  },

  {

    year: "Today",

    text:

      "770+ students from Nursery to Grade 12, supported by a comprehensive educational ecosystem.",

  },

];

const JOURNEY_TEXT =

  "What began with 54 students has grown into a thriving K–12 institution through the trust of parents, dedication of teachers and a continuous commitment to educational excellence.";

const ACADEMIC_PARAGRAPH =

  "Our academic approach combines concept-based teaching, regular assessment, individual attention, doubt-solving, remedial support and structured examination preparation. Our focus extends beyond examination results to developing knowledge, confidence, discipline and strong learning habits.";

const ACADEMIC_CARDS = [

  {

    title: "Conceptual Learning",

    text: "Strong understanding rather than rote learning.",

  },

  {

    title: "Individual Attention",

    text: "Monitoring and support according to student needs.",

  },

  {

    title: "Examination Readiness",

    text: "Systematic preparation and continuous assessment.",

  },

];

const FUTURE_CARDS = [

  {

    title: "Digital Classrooms",

    text: "Interactive technology-enabled learning.",

  },

  {

    title: "Robotics Lab",

    text: "Exploration of robotics, automation and problem-solving.",

  },

  {

    title: "Advanced STEM Labs",

    text: "Hands-on Science, Technology, Engineering and Mathematics.",

  },

  {

    title: "Computer Labs",

    text: "Modern computing facilities for digital literacy and technology skills.",

  },

];

const FUTURE_STATEMENT =

  "We believe today's education must prepare students not only for today's opportunities, but for a rapidly changing future.";

const SPORT_LEVELS = ["Taluka", "District", "State", "National"];

const SPORTS_TEXT =

  "Our students have achieved success in school sports competitions from Taluka to National level.";

const SPORTS_GROUPS = [

  {

    title: "Combat & Fitness",

    icon: "dumbbell",

    items: [

      "Boxing",

      "Taekwondo",

      "Karate",

      "Yoga",

      "Zumba",

      "Lathi-Kathi",

      "Fencing",

    ],

  },

  {

    title: "Team & Outdoor Sports",

    icon: "trophy",

    items: [

      "Kho-Kho",

      "Kabaddi",

      "Volleyball",

      "Football",

      "Throwball",

      "Cricket",

    ],

  },

  {

    title: "Indoor",

    icon: "table-tennis",

    items: ["Table Tennis", "Other indoor activities"],

  },

];

const SPORTS_HIGHLIGHT = [

  "Dedicated coaches",

  "Large playground",

  "Regular training",

  "Competitive opportunities",

];

const SPORT_PHOTOS = [

  { label: "Boxing", wide: true },

  { label: "Kho-Kho" },

  { label: "Cricket" },

  { label: "Yoga" },

  { label: "Volleyball" },

  { label: "Table Tennis", wide: true },

];

const BEYOND_CARDS = [

  { title: "Creativity", icon: "palette" },

  { title: "Communication", icon: "messages" },

  { title: "Confidence", icon: "target" },

  { title: "Teamwork", icon: "users" },

  { title: "Self-Expression", icon: "mic" },

  { title: "Discipline", icon: "shield-check" },

];

const BEYOND_TEXT =

  "Our co-curricular opportunities encourage students to explore their interests, discover their strengths and develop skills that extend beyond the classroom.";

const GALLERY_ITEMS = [

  "Main Campus",

  "Digital Classroom",

  "Robotics Lab",

  "STEM Lab",

  "Computer Lab",

  "Playground",

  "Multipurpose Hall",

  "Amphitheatre",

];

const CAMPUS_TEXT =

  "A picturesque campus with modern educational infrastructure provides students with dedicated spaces to learn, experiment, play, perform and grow.";

const SPACES = [

  {

    title: "Multipurpose Hall",

    caption: "Multipurpose Hall image",

    items: [

      "Seminars",

      "Workshops",

      "Indoor programmes",

      "Parent meetings",

      "Cultural activities",

      "Student presentations",

    ],

  },

  {

    title: "Outdoor Amphitheatre",

    caption: "Outdoor Amphitheatre image",

    items: [

      "Cultural programmes",

      "Performances",

      "Celebrations",

      "Student presentations",

      "School gatherings",

    ],

  },

];

const CARE_CARDS = [

  {

    icon: "bus",

    title: "Safe Transportation",

    text:

      "Safe and secure school bus facility for students travelling to and from campus.",

  },

  {

    icon: "house",

    title: "Residential Facilities",

    text:

      "Separate hostel facilities for boys and girls in a structured and supportive environment.",

  },

  {

    icon: "sun",

    title: "Day Boarding",

    text:

      "A convenient option for students spending an extended day on campus.",

  },

  {

    icon: "utensils",

    title: "Meals & Snacks",

    text: "Nutritious meals and snacks for day-boarder students.",

  },

];

const CARE_MESSAGE =

  "We understand that parents want their children to be not only well educated, but also safe, comfortable, cared for and supported throughout the school day.";

const ADVANTAGE = [

  { icon: "book-open", title: "Academics", text: "Strong foundations & consistent results" },

  { icon: "cpu", title: "Technology", text: "Digital • Robotics • STEM • Computing" },

  { icon: "trophy", title: "Sports", text: "Dedicated coaching & competitive opportunities" },

  { icon: "palette", title: "Co-Curricular", text: "Creativity • Communication • Confidence" },

  { icon: "building", title: "Infrastructure", text: "Modern classrooms, labs & activity spaces" },

  { icon: "heart-handshake", title: "Student Care", text: "Transport • Day Boarding • Meals" },

  { icon: "house", title: "Residential", text: "Separate boys' & girls' hostel facilities" },

  { icon: "shield-check", title: "Values", text: "Indian culture • Discipline • Character" },

];

const WHY_LIST = [

  "18+ Years of Educational Journey",

  "770+ Students",

  "Nursery to Grade 12",

  "10 Consecutive Years of 100% SSC & HSC Results",

  "Advanced Digital, Robotics & STEM Learning",

  "Taluka to National-Level Sports Achievements",

  "Dedicated Sports Coaches",

  "Wide Range of Co-Curricular Activities",

  "Modern Infrastructure",

  "Safe & Secure Transportation",

  "Separate Boys' & Girls' Hostels",

  "Day Boarding with Meals & Snacks",

  "Indian Values & Discipline",

];

const PHILOSOPHY_PARAGRAPHS = [

  "At Gurukul, we recognise that every child is unique. Some shine in academics, some in sports, technology, creativity or performance.",

  "Our role is to provide the environment, guidance, opportunities and encouragement that help each child discover their strengths and pursue excellence.",

];

const PHILOSOPHY_STATEMENT =

  "We prepare students not only for examinations, but for the opportunities and responsibilities of life.";

/* ------------------------------------------------------------------ */

const Counter = ({ value, suffix = "", duration = 1600 }) => {

  const [count, setCount] = useState(0);

  const [started, setStarted] = useState(false);

  const anchorRef = React.useRef(null);

  useEffect(() => {

    const el = anchorRef.current;

    if (!el || started) return undefined;

    const observer = new IntersectionObserver(

      (entries) => {

        if (entries[0].isIntersecting) {

          setStarted(true);

          observer.disconnect();

        }

      },

      { threshold: 0.2 }

    );

    observer.observe(el);

    return () => observer.disconnect();

  }, [started]);

  useEffect(() => {

    if (!started) return undefined;

    let frame;

    const startTime = performance.now();

    const tick = (now) => {

      const p = Math.min((now - startTime) / duration, 1);

      const eased = 1 - Math.pow(1 - p, 3);

      setCount(Math.round(value * eased));

      if (p < 1) frame = requestAnimationFrame(tick);

    };

    frame = requestAnimationFrame(tick);

    return () => cancelAnimationFrame(frame);

  }, [started, value, duration]);

  return (

    <span ref={anchorRef}>

      {count}

      {suffix}

    </span>

  );

};

// Blank, bordered area reserved for an image.

// size: hero | feature | large | medium | small  (responsive heights)

const IconGlyph = ({ name, size = 25 }) => {

  const common = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };

  const paths = {

    palette: <><path d="M12 3a9 9 0 1 0 0 18h1.2a1.8 1.8 0 0 0 1.3-3.1 1.8 1.8 0 0 1 1.3-3.1H18a3 3 0 0 0 3-3C21 7.1 17 3 12 3Z"/><circle cx="7.5" cy="10" r="1"/><circle cx="10" cy="6.8" r="1"/><circle cx="15" cy="7.5" r="1"/></>,

    messages: <><path d="M21 11.5a7.5 7.5 0 0 1-7.5 7.5H7l-4 2v-5.5A7.5 7.5 0 1 1 21 11.5Z"/><path d="M8 10h7M8 13h5"/></>,

    target: <><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/></>,

    users: <><path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="10" cy="7" r="4"/><path d="M20 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></>,

    mic: <><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8"/></>,

    "shield-check": <><path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z"/><path d="m9 12 2 2 4-4"/></>,

    dumbbell: <><path d="m6.5 6.5 11 11M4 9l5-5M15 20l5-5M2 7l5-5M17 22l5-5M3 10l7-7M14 21l7-7"/></>,

    trophy: <><path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4ZM7 6H4v2a4 4 0 0 0 4 4M17 6h3v2a4 4 0 0 1-4 4"/></>,

    "table-tennis": <><circle cx="15" cy="8" r="5"/><path d="m12 11-8 8M4 19l-1 3 3-1 8-8"/><circle cx="6" cy="5" r="1"/></>,

    bus: <><path d="M5 17h14M5 6l1-3h12l1 3M4 6h16v11H4zM7 17v3M17 17v3"/><circle cx="7.5" cy="13" r="1"/><circle cx="16.5" cy="13" r="1"/><path d="M7 8h10"/></>,

    house: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z"/><path d="M9 21v-7h6v7"/></>,

    sun: <><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42m11.3 11.3 1.42 1.42M2 12h2m16 0h2M4.93 19.07l1.42-1.42m11.3-11.3 1.42-1.42"/></>,

    utensils: <><path d="M3 2v7a4 4 0 0 0 4 4h1M7 2v20M3 2v5M11 2v5a4 4 0 0 1-4 4M17 2v20M17 2c4 4 4 8 0 10"/></>,

    "book-open": <><path d="M2 4.5A2.5 2.5 0 0 1 4.5 2H12v19H4.5A2.5 2.5 0 0 0 2 23ZM22 4.5A2.5 2.5 0 0 0 19.5 2H12v19h7.5A2.5 2.5 0 0 1 22 23Z"/></>,

    cpu: <><rect x="5" y="5" width="14" height="14" rx="2"/><rect x="9" y="9" width="6" height="6"/><path d="M9 1v4m6-4v4M9 19v4m6-4v4M1 9h4m-4 6h4m14-6h4m-4 6h4"/></>,

    building: <><rect x="4" y="2" width="16" height="20" rx="1"/><path d="M9 22v-4h6v4M8 6h2m4 0h2M8 10h2m4 0h2M8 14h2m4 0h2"/></>,

    "heart-handshake": <><path d="M20.8 8.5c0 5-8.8 10.5-8.8 10.5S3.2 13.5 3.2 8.5A4.5 4.5 0 0 1 12 6.4a4.5 4.5 0 0 1 8.8 2.1Z"/><path d="m8 12 2 2 2-1 2 2 3-3"/></>,

    "lightbulb": <><path d="M9 18h6M10 22h4M8 14a6 6 0 1 1 8 0c-1 .8-1.5 1.8-1.5 4h-5c0-2.2-.5-3.2-1.5-4Z"/></>,

    "user-round": <><circle cx="12" cy="8" r="5"/><path d="M3 22a9 9 0 0 1 18 0"/></>,

    "check-circle": <><circle cx="12" cy="12" r="9"/><path d="m8 12 2.5 2.5L16 9"/></>,

  };

  return <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" {...common}>{paths[name] || paths["lightbulb"]}</svg>;

};

const Placeholder = ({ size = "medium", caption, radius = "1rem" }) => (

  <div style={{ width: "100%" }}>

    <div

      role="img"

      aria-label={caption ? `Image placeholder: ${caption}` : "Image placeholder"}

      className={`ga-ph ga-ph--${size}`}

      style={{ borderRadius: radius }}

    />

    {caption ? <div className="ga-ph-caption">{caption}</div> : null}

  </div>

);

// Image tile with a label bar — used for the sports photo grid.

const PhotoTile = ({ label }) => (

  <div className="ga-tile">

    <div

      role="img"

      aria-label={`Image placeholder: ${label}`}

      className="ga-ph ga-ph--medium"

    />

    <span className="ga-tile-label">{label}</span>

  </div>

);

const SectionHead = ({ title, sub }) => (

  <motion.div

    className="ga-head"

    variants={staggerContainer}

    initial="hidden"

    whileInView="show"

    viewport={{ once: true }}

  >

    <Reveal as={motion.h2} variants={revealUp} className="ga-title">

      {title.trim().includes(" ") ? (
        <>
          {title.trim().slice(0, title.trim().lastIndexOf(" ") + 1)}
          <span className="gradient-text">
            {title.trim().slice(title.trim().lastIndexOf(" ") + 1)}
          </span>
        </>
      ) : (
        <span className="gradient-text">{title}</span>
      )}

    </Reveal>

    {sub ? (

      <Reveal as={motion.p} variants={revealUp} className="ga-sub">

        {sub}

      </Reveal>

    ) : null}

  </motion.div>

);

const EnglishAcademyShowcase = () => {

  const { colors } = useTheme();

  const goTo = (id) => {

    const el = document.getElementById(id);

    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });

  };

  const rootStyle = {

    "--ga-primary": colors.primary,

    "--ga-primary-dark": colors.primaryDark,

    "--ga-secondary": colors.secondary,

    "--ga-text-light": colors.textLight,

    "--ga-hover": colors.hover,

    "--ga-overlay": colors.overlay,

    "--ga-button-primary": colors.buttonPrimary,

    "--ga-button-text": colors.buttonText,

    "--ga-text": colors.text,

    "--ga-text2": colors.textSecondary,

    "--ga-bg": colors.background,
    "--ga-bg-gradient": colors.backgroundGradient,

    "--ga-bg-alt": colors.backgroundAlt,

    "--ga-card": colors.card,

    "--ga-border": colors.border,

    "--ga-shadow": colors.cardShadow,

  };

  return (

    <div className="ga-root" style={rootStyle}>

      <style>{`

        .ga-root { position: relative; color: var(--ga-text); font-family: inherit; }

        .ga-section { padding: 4.5rem 1.5rem; scroll-margin-top: 116px; position: relative; }

        .ga-section--alt { background: var(--ga-bg-alt); }

        .ga-section--plain { background: var(--ga-bg); }

        .ga-wrap { max-width: 1200px; margin: 0 auto; }

        .ga-head { text-align: center; margin-bottom: 2.75rem; }

        .ga-title {

          font-size: clamp(1.75rem, 3.6vw, 2.6rem); font-weight: 700;

          line-height: 1.2; margin: 0 0 0.6rem; color: var(--ga-text);

        }

        .ga-sub { font-size: 1.08rem; color: var(--ga-text2); max-width: 840px; margin: 0 auto; }

        .ga-card {

          background: var(--ga-card); border: 1px solid var(--ga-border);

          border-radius: 1.1rem; padding: 1.6rem; box-shadow: var(--ga-shadow);

          transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;

        }

        .ga-card:hover {

          transform: translateY(-6px); border-color: var(--ga-primary);

          box-shadow: 0 16px 32px color-mix(in srgb, var(--ga-primary) 16%, transparent);

        }

        .ga-grid { display: grid; gap: 1.5rem; }

        .ga-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

        .ga-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

        .ga-grid-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }

        .ga-grid-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }

        .ga-grid-6 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

        .ga-grid-8 { grid-template-columns: repeat(4, minmax(0, 1fr)); }

        /* Beyond Academics: continuous left-moving card strip */

        .ga-beyond-marquee {

          width: 100%;

          overflow: hidden;

          position: relative;

          padding: 0.35rem 0 0.8rem;

        }

        .ga-beyond-track {

          display: flex;

          width: max-content;

          gap: 1.5rem;

          animation: ga-beyond-scroll 28s linear infinite;

          will-change: transform;

        }

        .ga-beyond-marquee:hover .ga-beyond-track,

        .ga-beyond-marquee:focus-within .ga-beyond-track {

          animation-play-state: paused;

        }

        .ga-beyond-card {

          flex: 0 0 clamp(170px, 22vw, 250px);

          min-height: 130px;

          display: flex;

          align-items: center;

          justify-content: center;

        }

        @keyframes ga-beyond-scroll {

          from { transform: translateX(0); }

          to { transform: translateX(calc(-50% - 0.75rem)); }

        }

        @media (prefers-reduced-motion: reduce) {

          .ga-beyond-track { animation: none; }

        }

        .ga-ph {

          width: 100%; border: 2px dashed var(--ga-primary); display: block;

          background-image: repeating-linear-gradient(

            135deg,

            color-mix(in srgb, var(--ga-primary) 10%, transparent) 0 10px,

            transparent 10px 22px

          );

        }

        /* Responsive image sizes — big on desktop, compact on mobile */

        .ga-ph--hero { height: clamp(300px, 42vw, 560px); }

        .ga-ph--feature { height: clamp(300px, 40vw, 520px); }

        .ga-ph--large { height: clamp(260px, 28vw, 420px); }

        .ga-ph--medium { height: clamp(210px, 19vw, 320px); }

        .ga-ph--small { height: clamp(180px, 16vw, 260px); }

        .ga-ph-caption {

          margin-top: 0.6rem; font-size: 0.85rem; color: var(--ga-text2);

          text-align: center; font-weight: 500;

        }

        /* Sports photo grid */

        .ga-mosaic { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.25rem; }

        .ga-tile {

          position: relative; overflow: hidden; border-radius: 1rem;

          box-shadow: var(--ga-shadow);

        }

        .ga-tile--wide { grid-column: span 2; }

        .ga-tile .ga-ph {

          height: clamp(220px, 20vw, 340px);

          transition: transform .45s ease, border-color .45s ease;

          background-color: var(--ga-card);

        }

        .ga-tile:hover .ga-ph { transform: scale(1.05); border-color: var(--ga-primary-dark); }

        .ga-tile-label {

          position: absolute; left: 0; right: 0; bottom: 0;

          padding: 1.8rem 0.9rem 0.7rem; font-size: 0.92rem; font-weight: 600;

          color: #ffffff; letter-spacing: 0.02em;

          background: linear-gradient(to top, color-mix(in srgb, var(--ga-primary-dark) 92%, transparent) 0%, transparent 100%);

          transform: translateY(4px); transition: transform .35s ease;

        }

        .ga-tile:hover .ga-tile-label { transform: translateY(0); }

        .ga-chip {

          display: inline-flex; align-items: center; gap: 0.4rem;

          padding: 0.45rem 1rem; border-radius: 999px; font-size: 0.92rem;

          font-weight: 600; color: var(--ga-primary-dark);

          background: color-mix(in srgb, var(--ga-primary) 10%, transparent); border: 1px solid color-mix(in srgb, var(--ga-primary) 35%, transparent);

          transition: transform .25s ease, background .25s ease;

        }

        .ga-chip:hover { transform: translateY(-3px); background: color-mix(in srgb, var(--ga-primary) 18%, transparent); }

        .ga-btn {

          display: inline-flex; align-items: center; justify-content: center;

          gap: 0.5rem; padding: 0.85rem 1.7rem; border-radius: 0.7rem;

          font-family: inherit; font-size: 1rem; font-weight: 600; cursor: pointer;

          border: none; transition: transform .25s ease, box-shadow .25s ease, background .25s ease;

        }

        .ga-btn:hover { transform: translateY(-3px); }

        .ga-btn-primary {

          background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%);

          color: #fff; box-shadow: 0 10px 20px color-mix(in srgb, var(--ga-primary) 30%, transparent);

        }

        .ga-btn-primary:hover { box-shadow: 0 14px 26px color-mix(in srgb, var(--ga-primary) 40%, transparent); }

        .ga-btn-outline {

          background: transparent; color: var(--ga-primary-dark);

          border: 2px solid var(--ga-primary);

        }

        .ga-btn-outline:hover { background: color-mix(in srgb, var(--ga-primary) 12%, transparent); }

        .ga-btn-light { background: #ffffff; color: var(--ga-primary-dark); box-shadow: 0 10px 20px rgba(0,0,0,0.18); }

        .ga-btn-ghost { background: transparent; color: #ffffff; border: 2px solid rgba(255,255,255,0.85); }

        .ga-btn-ghost:hover { background: rgba(255,255,255,0.15); }

        /* Hero */

        .ga-hero {

          background: linear-gradient(135deg, var(--ga-primary-dark) 0%, var(--ga-primary) 100%);

          color: #ffffff; padding-top: 3.5rem; padding-bottom: 3.5rem;

        }

        .ga-hero .ga-ph { border-color: rgba(255,255,255,0.8); background-image: repeating-linear-gradient(135deg, rgba(255,255,255,0.12) 0 10px, rgba(255,255,255,0) 10px 22px); }

        .ga-hero-title {

          font-size: clamp(2rem, 5vw, 3.4rem); font-weight: 800; line-height: 1.15;

          margin: 2rem 0 1rem; color: #ffffff;

        }

        .ga-hero-lead { font-size: 1.1rem; line-height: 1.7; color: rgba(255,255,255,0.92); max-width: 900px; margin: 0 0 1.6rem; }

        .ga-hero-chips { display: flex; flex-wrap: wrap; gap: 0.7rem; margin-bottom: 1.8rem; }

        .ga-hero-chips .ga-chip {

          background: rgba(255,255,255,0.16); border-color: rgba(255,255,255,0.5); color: #ffffff;

          font-size: 1rem; padding: 0.55rem 1.1rem;

        }

        .ga-hero-chips .ga-chip:hover { background: rgba(255,255,255,0.28); }

        .ga-actions { display: flex; flex-wrap: wrap; gap: 1rem; margin-bottom: 1.2rem; }

        .ga-note { font-size: 0.9rem; color: rgba(255,255,255,0.85); margin: 0; }

        /* Glance */

        .ga-stat { text-align: center; padding: 1.75rem 1rem; }

        .ga-stat-value {

          font-size: clamp(2rem, 4vw, 2.75rem); font-weight: 800;

          background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%);

          -webkit-background-clip: text; background-clip: text;

          -webkit-text-fill-color: transparent; line-height: 1.1;

        }

        .ga-stat-label { margin-top: 0.5rem; color: var(--ga-text2); font-size: 0.98rem; }

        /* Journey */

        .ga-timeline { display: flex; flex-wrap: wrap; gap: 1rem; align-items: stretch; }

        .ga-timeline .ga-node { flex: 1 1 260px; }

        .ga-node { position: relative; text-align: left; }

        .ga-node-year {

          display: inline-block; padding: 0.3rem 0.9rem; border-radius: 999px;

          background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%);

          color: #fff; font-weight: 700; font-size: 0.95rem; margin-bottom: 0.9rem;

        }

        .ga-node-arrow {

          display: flex; align-items: center; justify-content: center;

          color: var(--ga-primary); font-size: 1.6rem; font-weight: 700;

        }

        .ga-quote {

          background: var(--ga-card); border-left: 5px solid var(--ga-primary);

          border-radius: 0.75rem; padding: 1.4rem 1.6rem; color: var(--ga-text);

          font-size: 1.05rem; line-height: 1.75; box-shadow: var(--ga-shadow);

        }

        /* Big 100% visual */

        .ga-percent {

          display: flex; flex-direction: column; align-items: center; justify-content: center;

          text-align: center; padding: 2.5rem 1.5rem; border-radius: 1rem;

          background: linear-gradient(135deg, var(--ga-primary-dark) 0%, var(--ga-primary) 100%); color: #fff;

          box-shadow: 0 18px 36px rgba(3, 105, 161, 0.28);

        }

        .ga-percent-number { font-size: clamp(4rem, 10vw, 6rem); font-weight: 800; line-height: 1; }

        .ga-percent-years { font-size: 1.15rem; font-weight: 600; margin-top: 0.75rem; opacity: 0.95; }

        .ga-percent-label { font-size: 1.35rem; font-weight: 700; margin-top: 0.35rem; }

        .ga-icon {

          width: 52px; height: 52px; border-radius: 0.9rem; display: flex;

          align-items: center; justify-content: center; font-size: 1.5rem;

          background: color-mix(in srgb, var(--ga-primary) 12%, transparent); border: 1px solid color-mix(in srgb, var(--ga-primary) 30%, transparent);

          margin-bottom: 1rem;

        }

        .ga-icon { position: relative; }

        .ga-icon::before {

          content: ""; display: block; width: 18px; height: 18px;

          border: 2px solid var(--ga-primary); border-radius: 5px;

          transform: rotate(45deg); opacity: 0.9;

        }

        .ga-card-title { font-size: 1.2rem; font-weight: 700; color: var(--ga-text); margin: 0 0 0.5rem; }

        .ga-card-text { color: var(--ga-text2); margin: 0; line-height: 1.65; }

        .ga-statement {

          margin-top: 2rem; text-align: center; padding: 1.6rem 1.8rem;

          border-radius: 1rem; font-size: 1.12rem; line-height: 1.7; font-weight: 500;

          background: color-mix(in srgb, var(--ga-primary) 10%, transparent); border: 1px solid color-mix(in srgb, var(--ga-primary) 35%, transparent);

          color: var(--ga-text);

        }

        .ga-levels { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 0.6rem; margin: 1.5rem 0; }

        .ga-level-arrow { color: var(--ga-primary); font-weight: 800; font-size: 1.2rem; }

        .ga-sports-list { display: flex; flex-wrap: wrap; gap: 0.55rem; margin-top: 1rem; }

        .ga-sports-list .ga-chip { cursor: default; }

        .ga-check {

          display: flex; align-items: flex-start; gap: 0.75rem; padding: 0.85rem 1rem;

          border-radius: 0.75rem; background: var(--ga-card); border: 1px solid var(--ga-border);

          transition: transform .25s ease, border-color .25s ease, box-shadow .25s ease;

        }

        .ga-check:hover { transform: translateX(6px); border-color: var(--ga-primary); box-shadow: 0 10px 20px color-mix(in srgb, var(--ga-primary) 12%, transparent); }

        .ga-check-mark {

          flex: 0 0 auto; width: 26px; height: 26px; border-radius: 50%;

          display: flex; align-items: center; justify-content: center;

          background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%);

          color: #fff; font-size: 0.85rem; font-weight: 700;

        }

        .ga-check-text { color: var(--ga-text); font-weight: 500; line-height: 1.5; }

        .ga-space-list { list-style: none; padding: 0; margin: 1rem 0 0; display: grid; gap: 0.5rem; }

        .ga-space-list li { display: flex; gap: 0.6rem; align-items: center; color: var(--ga-text2); }

        .ga-space-list li::before { content: "▸"; color: var(--ga-primary); font-weight: 700; }

        .ga-final {

          background: linear-gradient(135deg, var(--ga-primary-dark) 0%, var(--ga-primary) 100%);

          color: #fff; text-align: center;

        }

        .ga-final .ga-ph { border-color: rgba(255,255,255,0.8); background-image: repeating-linear-gradient(135deg, rgba(255,255,255,0.12) 0 10px, rgba(255,255,255,0) 10px 22px); }

        .ga-final .ga-ph-caption { color: rgba(255,255,255,0.85); }

        .ga-final-title { font-size: clamp(1.8rem, 4vw, 2.8rem); font-weight: 800; line-height: 1.2; margin: 2rem 0 1rem; color: #fff; }

        .ga-final-school { font-size: 1.15rem; font-weight: 600; color: rgba(255,255,255,0.95); margin: 0 0 0.6rem; }

        .ga-badge {

          display: inline-block; padding: 0.4rem 1.1rem; border-radius: 999px;

          background: rgba(255,255,255,0.18); border: 1px solid rgba(255,255,255,0.5);

          font-weight: 600; margin-bottom: 1.6rem;

        }

        .ga-tagline { margin-top: 1.5rem; font-size: 1.1rem; font-style: italic; color: rgba(255,255,255,0.92); }

        .ga-center { text-align: center; }

        .ga-mt-2 { margin-top: 2rem; }

        .ga-mb-1 { margin-bottom: 1rem; }

        @media (min-width: 1025px) {

          .ga-mosaic { grid-template-columns: repeat(4, 1fr); }

        }

        @media (max-width: 1024px) {

          .ga-grid { gap: 1.25rem; }

          .ga-grid-3, .ga-grid-4 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

          .ga-grid-5 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

          .ga-grid-5 > :last-child { grid-column: span 2; }

          .ga-grid-8 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

        }

        @media (max-width: 768px) {

          .ga-section { padding: 3rem 1.1rem; scroll-margin-top: 100px; }

          .ga-head { margin-bottom: 2rem; }

          .ga-grid { gap: 1rem; }

          .ga-grid-2, .ga-grid-6, .ga-grid-8 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

          .ga-node-arrow { transform: rotate(90deg); }

          .ga-mosaic { gap: 1rem; }

          .ga-ph--hero { height: 240px; }

          .ga-ph--feature { height: 240px; }

          .ga-ph--large { height: 210px; }

          .ga-ph--medium { height: 190px; }

          .ga-ph--small { height: 160px; }

          .ga-tile .ga-ph { height: 180px; }

          .ga-tile--wide .ga-ph { height: 210px; }

          .ga-actions { gap: 0.75rem; }

          .ga-actions .ga-btn { flex: 1 1 220px; }

        }

        @media (max-width: 560px) {

          .ga-grid-2, .ga-grid-3, .ga-grid-4 { grid-template-columns: minmax(0, 1fr); }

          .ga-grid-5 > :last-child { grid-column: span 1; }

          .ga-stat-value { font-size: 1.7rem; }

          .ga-percent { padding: 2rem 1rem; }

        }

        /* Refined editorial styling using the active ThemeContext palette. */

        .ga-root { isolation: isolate; }

        .ga-section--alt { background: var(--ga-bg-alt); }

        .ga-section--plain { background: var(--ga-bg); }

        .ga-wrap { max-width: 1240px; }

        .ga-title { letter-spacing: -0.035em; font-weight: 700; position: relative; display: inline-block; padding-bottom: 0; line-height: 1.3; }

        .ga-title::after { content: none; }

        .ga-title .gradient-text { background: linear-gradient(135deg, var(--ga-primary) 0%, var(--ga-primary-dark) 100%); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; color: transparent; }

        [data-theme="dark"] .ga-title .gradient-text { background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; color: transparent; }

        .ga-sub { color: var(--ga-text2); line-height: 1.75; }

        .ga-card { background: var(--ga-card); border: 1px solid var(--ga-border); border-radius: 1.25rem; padding: 1.7rem; box-shadow: var(--ga-shadow); }

        .ga-card:hover { transform: translateY(-5px); border-color: var(--ga-primary); box-shadow: 0 16px 32px color-mix(in srgb, var(--ga-primary) 18%, transparent); }

        .ga-ph { border: 1px solid var(--ga-border); background-color: var(--ga-bg-alt); background-image: linear-gradient(135deg, color-mix(in srgb, var(--ga-primary) 8%, transparent), transparent), repeating-linear-gradient(135deg, color-mix(in srgb, var(--ga-text) 3%, transparent) 0 12px, transparent 12px 26px); }

        .ga-ph-caption { color: var(--ga-text2); }

        .ga-tile { border-radius: 1.25rem; box-shadow: var(--ga-shadow); }

        .ga-tile-label { background: linear-gradient(to top, color-mix(in srgb, var(--ga-bg) 96%, transparent) 0%, transparent 100%); }

        .ga-chip { background: var(--ga-card); border: 1px solid var(--ga-border); color: var(--ga-text); box-shadow: var(--ga-shadow); }

        .ga-chip:hover { background: var(--ga-hover, var(--ga-bg-alt)); }

        .ga-btn { border-radius: .65rem; letter-spacing: .005em; }

        .ga-btn-primary { background: var(--ga-primary); color: var(--ga-button-text, #fff); box-shadow: 0 9px 20px color-mix(in srgb, var(--ga-primary) 24%, transparent); }

        .ga-btn-primary:hover { box-shadow: 0 12px 24px color-mix(in srgb, var(--ga-primary) 32%, transparent); }

        .ga-btn-outline { color: var(--ga-primary); border-color: var(--ga-primary); }

        .ga-btn-outline:hover { background: color-mix(in srgb, var(--ga-primary) 12%, transparent); }

        .ga-btn-light { color: var(--ga-primary-dark); background: var(--ga-card); }

        .ga-btn-ghost { color: var(--ga-text); border-color: color-mix(in srgb, var(--ga-text) 35%, transparent); }

        .ga-hero { color: var(--ga-text); overflow: hidden; background: var(--ga-bg); padding-top: 4rem; padding-bottom: 4rem; position: relative; }

        .ga-hero::before, .ga-final::before { content: none; }

        .ga-hero .ga-wrap, .ga-final .ga-wrap { position: relative; z-index: 1; }

        .ga-hero .ga-ph, .ga-final .ga-ph { border-color: color-mix(in srgb, var(--ga-border) 80%, transparent); background-color: color-mix(in srgb, var(--ga-primary) 7%, var(--ga-bg)); box-shadow: var(--ga-shadow); }

        .ga-hero-title, .ga-final-title { color: var(--ga-text); letter-spacing: -.035em; text-wrap: balance; }

        .ga-hero-title { max-width: 920px; color: var(--ga-text); }

        .ga-hero-lead { max-width: 860px; color: var(--ga-text2); }

        .ga-hero-chips .ga-chip { background: color-mix(in srgb, var(--ga-card) 90%, transparent); border-color: var(--ga-border); color: var(--ga-text); box-shadow: none; backdrop-filter: blur(8px); }

        .ga-note { color: var(--ga-text2); }

        .ga-stat { background: var(--ga-card); border: 1px solid var(--ga-border); border-radius: 1rem; padding: 1.55rem 1rem; box-shadow: var(--ga-shadow); }

        .ga-stat-value { background: none; color: var(--ga-text); -webkit-text-fill-color: var(--ga-text); letter-spacing: -.04em; }

        .ga-stat-label { color: var(--ga-text2); line-height: 1.5; }

        .ga-node-year { background: var(--ga-primary); color: var(--ga-button-text, #fff); border-radius: .45rem; box-shadow: inset 3px 0 0 var(--ga-primary-dark); }

        .ga-node-arrow { color: var(--ga-primary); }

        .ga-quote { background: var(--ga-bg-alt); border-left: 4px solid var(--ga-primary); border-radius: .35rem 1rem 1rem .35rem; box-shadow: none; }

        .ga-percent { background: var(--ga-bg-alt); border: 1px solid var(--ga-border); border-left: 4px solid var(--ga-primary); border-radius: .35rem 1rem 1rem .35rem; box-shadow: var(--ga-shadow); position: relative; overflow: hidden; color: var(--ga-text); }

        .ga-percent::after { content: none; }

        .ga-percent-number { color: var(--ga-text); }

        .ga-icon { color: var(--ga-primary); border-radius: .75rem; background: color-mix(in srgb, var(--ga-primary) 12%, var(--ga-card)); border: 1px solid color-mix(in srgb, var(--ga-primary) 28%, var(--ga-border)); }

        .ga-icon::before { content: none; }

        .ga-card-title { color: var(--ga-text); letter-spacing: -.015em; }

        .ga-card-text { color: var(--ga-text2); }

        .ga-statement { background: var(--ga-bg-alt); border: 1px solid var(--ga-border); border-left: 4px solid var(--ga-primary); border-radius: .35rem 1rem 1rem .35rem; }

        .ga-level-arrow { color: var(--ga-primary); }

        .ga-check { border-color: var(--ga-border); border-radius: .85rem; box-shadow: var(--ga-shadow); }

        .ga-check:hover { border-color: var(--ga-primary); box-shadow: 0 10px 22px color-mix(in srgb, var(--ga-primary) 12%, transparent); }

        .ga-check-mark { background: var(--ga-primary); color: var(--ga-button-text, #fff); }

        .ga-check-text { color: var(--ga-text); }

        .ga-space-list li::before { content: "✓"; color: var(--ga-primary); }

        .ga-final { color: var(--ga-text); overflow: hidden; background: var(--ga-bg-alt); position: relative; }

        .ga-final .ga-badge { background: var(--ga-card); border-color: var(--ga-border); color: var(--ga-text); }

        .ga-tagline { color: var(--ga-primary); }

        .ga-root :focus-visible { outline: 3px solid var(--ga-primary); outline-offset: 3px; }

        /* Typography follows the site's global font; compact, touch-friendly mobile layout. */

        .ga-root, .ga-root * { font-family: inherit; }

        .ga-root { font-size: 1rem; }

        @media (max-width: 768px) {

          .ga-section { padding: 2.5rem 1rem; scroll-margin-top: 88px; }

          .ga-wrap { width: 100%; }

          .ga-head { margin-bottom: 1.5rem; }

          .ga-title { font-size: clamp(1.45rem, 4.8vw, 1.8rem); line-height: 1.25; font-weight: 700; letter-spacing: normal; padding-bottom: .6rem; }

          .ga-title::after { width: 42px; height: 3px; }

          .ga-sub { font-size: .92rem; line-height: 1.55; }

          .ga-card { padding: 1.1rem; border-radius: .9rem; }

          .ga-card-title { font-size: 1rem; line-height: 1.35; letter-spacing: normal; }

          .ga-card-text { font-size: .9rem; line-height: 1.55; }

          .ga-hero { padding-top: 2.25rem; padding-bottom: 2.25rem; }

          .ga-hero-title { font-size: clamp(1.7rem, 6vw, 2.15rem); line-height: 1.2; font-weight: 700; letter-spacing: normal; margin: 1.25rem 0 .75rem; }

          .ga-hero-lead { font-size: .95rem; line-height: 1.6; margin-bottom: 1.1rem; }

          .ga-hero-chips { gap: .5rem; margin-bottom: 1.2rem; }

          .ga-hero-chips .ga-chip { font-size: .82rem; padding: .4rem .7rem; }

          .ga-grid { gap: .8rem; }

          .ga-stat { padding: 1rem .7rem; }

          .ga-stat-value { font-size: clamp(1.35rem, 5vw, 1.7rem); letter-spacing: normal; }

          .ga-stat-label { font-size: .8rem; line-height: 1.4; }

          .ga-icon { width: 2.4rem; height: 2.4rem; font-size: 1.15rem; }

          .ga-actions { gap: .65rem; }

          .ga-actions .ga-btn { flex: 1 1 100%; min-height: 44px; padding: .75rem 1rem; font-size: .92rem; }

          .ga-percent { padding: 1.5rem 1rem; border-radius: 1rem; }

          .ga-percent-number { font-size: clamp(2.8rem, 12vw, 4rem); }

          .ga-percent-label { font-size: 1.05rem; }

          .ga-final-title { font-size: clamp(1.55rem, 5.5vw, 2rem); line-height: 1.25; font-weight: 700; letter-spacing: normal; }

          .ga-final-school { font-size: .95rem; line-height: 1.5; }

          .ga-beyond-track { gap: .8rem; }

          .ga-beyond-card { flex-basis: min(68vw, 210px); min-height: 112px; }

          .ga-hero::before, .ga-final::before { width: 220px; height: 220px; right: -100px; top: -100px; }

        }

        @media (max-width: 560px) {

          .ga-section { padding: 2rem .85rem; }

          .ga-head { margin-bottom: 1.25rem; }

          .ga-title { font-size: 1.45rem; }

          .ga-sub { font-size: .88rem; }

          .ga-grid-2, .ga-grid-3, .ga-grid-4 { grid-template-columns: minmax(0, 1fr); }

          .ga-grid-5 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

          .ga-grid-5 > :last-child { grid-column: span 2; }

          .ga-card { padding: .95rem; }

          .ga-hero { padding: 1.75rem .85rem; }

          .ga-hero-title { font-size: 1.7rem; }

          .ga-hero-lead { font-size: .9rem; }

          .ga-ph--hero { height: 175px; }

          .ga-ph--feature { height: 190px; }

          .ga-ph--large { height: 170px; }

          .ga-ph--medium { height: 145px; }

          .ga-ph--small { height: 125px; }

          .ga-tile .ga-ph { height: 145px; }

          .ga-tile--wide .ga-ph { height: 170px; }

          .ga-check { padding: .75rem; gap: .65rem; }

          .ga-check-text { font-size: .88rem; line-height: 1.45; }

          .ga-node-arrow { font-size: 1rem; }

          .ga-tagline { font-size: .92rem; }

        }

        @media (prefers-reduced-motion: reduce) {

          .ga-beyond-track { animation: none; }

          .ga-card { transition: none; }

        }

      
        /* Theme-aligned refinements: follow the shared Home page palette. */
        .ga-root {
          background: var(--ga-bg);
          color: var(--ga-text);
          font-family: inherit;
          overflow: hidden;
        }
        .ga-section { padding: 4rem 1.5rem; }
        .ga-section--alt { background: var(--ga-bg-alt); }
        .ga-section--plain { background: var(--ga-bg); }
        .ga-wrap { width: 100%; max-width: 1240px; }
        .ga-head { margin-bottom: 2.25rem; }
        .ga-title {
          font-size: clamp(1.65rem, 3vw, 2.35rem);
          line-height: 1.3;
          letter-spacing: -0.025em;
        }
        .ga-sub {
          max-width: 820px;
          font-size: 1rem;
          line-height: 1.8;
          color: var(--ga-text2);
        }
        .ga-card {
          border: 1px solid color-mix(in srgb, var(--ga-text2) 18%, transparent);
          border-radius: 16px;
          padding: 1.5rem;
          box-shadow: var(--ga-shadow);
          background: var(--ga-card);
        }
        .ga-card:hover {
          transform: translateY(-3px);
          border-color: color-mix(in srgb, var(--ga-text2) 32%, transparent);
          box-shadow: var(--ga-shadow);
        }
        .ga-hero,
        .ga-final {
          background: var(--ga-bg-gradient, linear-gradient(135deg, var(--ga-bg-alt), var(--ga-bg)));
          color: var(--ga-text);
        }
        .ga-hero-title, .ga-final-title { color: var(--ga-text); }
        .ga-hero-lead, .ga-hero .ga-note,
        .ga-final-school, .ga-tagline { color: var(--ga-text2); }
        .ga-hero .ga-ph, .ga-final .ga-ph {
          border-color: color-mix(in srgb, var(--ga-text2) 35%, transparent);
          background-image: repeating-linear-gradient(
            135deg,
            color-mix(in srgb, var(--ga-text2) 6%, transparent) 0 10px,
            transparent 10px 22px
          );
        }
        .ga-chip {
          color: var(--ga-text);
          background: color-mix(in srgb, var(--ga-primary) 8%, var(--ga-card));
          border: 1px solid color-mix(in srgb, var(--ga-text2) 22%, transparent);
        }
        .ga-hero-chips .ga-chip {
          color: var(--ga-text);
          background: color-mix(in srgb, var(--ga-card) 78%, transparent);
          border-color: color-mix(in srgb, var(--ga-text2) 25%, transparent);
        }
        .ga-btn-primary {
          background: var(--ga-button-primary);
          color: var(--ga-button-text);
          box-shadow: var(--ga-shadow);
        }
        .ga-btn-outline {
          color: var(--ga-primary);
          border: 1px solid var(--ga-border);
        }
        .ga-btn-light {
          background: var(--ga-card);
          color: var(--ga-text);
          border: 1px solid var(--ga-border);
          box-shadow: var(--ga-shadow);
        }
        .ga-btn-ghost {
          color: var(--ga-text);
          border: 1px solid var(--ga-border);
        }
        .ga-stat-value {
          background: none;
          -webkit-text-fill-color: currentColor;
          color: var(--ga-primary);
        }
        .ga-node-year, .ga-check-mark {
          background: var(--ga-primary);
          color: var(--ga-button-text);
        }
        .ga-percent {
          background: var(--ga-card);
          color: var(--ga-text);
          border: 1px solid var(--ga-border);
          box-shadow: var(--ga-shadow);
        }
        .ga-percent-number { color: var(--ga-primary); }
        .ga-icon {
          width: 46px;
          height: 46px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--ga-primary);
          background: color-mix(in srgb, var(--ga-primary) 9%, var(--ga-card));
          border: 1px solid color-mix(in srgb, var(--ga-text2) 18%, transparent);
          margin-bottom: 1rem;
        }
        .ga-icon::before { content: none; display: none; }
        .ga-icon svg { width: 23px; height: 23px; }
        .ga-statement {
          background: color-mix(in srgb, var(--ga-primary) 7%, var(--ga-card));
          border: 1px solid color-mix(in srgb, var(--ga-text2) 20%, transparent);
          border-radius: 14px;
        }
        .ga-ph {
          border: 1px dashed color-mix(in srgb, var(--ga-text2) 40%, transparent);
          background-color: var(--ga-card);
          background-image: repeating-linear-gradient(
            135deg,
            color-mix(in srgb, var(--ga-text2) 5%, transparent) 0 10px,
            transparent 10px 22px
          );
        }
        .ga-check {
          background: var(--ga-card);
          border-color: color-mix(in srgb, var(--ga-text2) 18%, transparent);
        }
        .ga-check:hover {
          transform: translateY(-2px);
          border-color: color-mix(in srgb, var(--ga-text2) 32%, transparent);
          box-shadow: var(--ga-shadow);
        }
        .ga-tile-label {
          background: linear-gradient(to top, rgba(15, 23, 42, .86), transparent);
        }
        @media (max-width: 768px) {
          .ga-section { padding: 2.75rem 1rem; scroll-margin-top: 100px; }
          .ga-title { font-size: 1.7rem; }
          .ga-sub { font-size: .94rem; line-height: 1.7; }
          .ga-card { padding: 1.2rem; border-radius: 14px; }
          .ga-hero-title, .ga-final-title { font-size: clamp(1.8rem, 7vw, 2.4rem); }
          .ga-hero-lead { font-size: .98rem; line-height: 1.7; }
          .ga-btn { padding: .75rem 1.1rem; font-size: .92rem; }
          .ga-stat { padding: 1.1rem .6rem; }
        }
        @media (max-width: 480px) {
          .ga-section { padding: 2.25rem .875rem; }
          .ga-head { margin-bottom: 1.6rem; }
          .ga-title { font-size: 1.5rem; }
          .ga-sub { font-size: .9rem; }
          .ga-grid { gap: .85rem; }
          .ga-card { padding: 1rem; }
          .ga-actions { gap: .65rem; }
          .ga-actions .ga-btn { width: 100%; }
          .ga-chip { font-size: .82rem; padding: .38rem .75rem; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ga-card, .ga-btn, .ga-chip, .ga-check { transition: none; }
          .ga-card:hover, .ga-btn:hover, .ga-chip:hover, .ga-check:hover { transform: none; }
        }

        /* Final alignment with the Home page: restrained surfaces, typography, spacing and shadows. */
        .ga-root { background: var(--ga-bg); color: var(--ga-text); }
        .ga-section { box-sizing: border-box; }
        .ga-section--plain { background: var(--ga-bg); }
        .ga-section--alt { background: var(--ga-bg-alt); }
        .ga-wrap { max-width: 1240px; }
        .ga-head { margin-bottom: 2.5rem; }
        .ga-title {
          font-size: clamp(1.8rem, 3vw, 2.5rem);
          font-weight: 700;
          line-height: 1.3;
          letter-spacing: -0.02em;
          padding-bottom: 0;
          margin-bottom: .75rem;
        }
        .ga-title::after { display: none; }
        .ga-sub { max-width: 820px; font-size: 1rem; line-height: 1.8; }
        .ga-card, .ga-check, .ga-tile {
          background: var(--ga-card);
          border: 1px solid color-mix(in srgb, var(--ga-text2) 18%, transparent);
          border-radius: 16px;
          box-shadow: var(--ga-shadow);
        }
        .ga-card { padding: 1.6rem; }
        .ga-card:hover, .ga-check:hover {
          transform: translateY(-3px);
          border-color: color-mix(in srgb, var(--ga-text2) 30%, transparent);
          box-shadow: var(--ga-shadow);
        }
        .ga-card-title { font-size: 1.2rem; line-height: 1.45; font-weight: 700; }
        .ga-card-text { font-size: 1rem; line-height: 1.75; }
        .ga-hero, .ga-final {
          background: var(--ga-bg);
          color: var(--ga-text);
        }
        .ga-hero::before, .ga-final::before { display: none; }
        .ga-hero-title, .ga-final-title {
          color: var(--ga-text);
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 700;
          line-height: 1.25;
          letter-spacing: -0.025em;
        }
        .ga-hero-lead, .ga-final-school, .ga-tagline { color: var(--ga-text2); }
        .ga-hero .ga-ph, .ga-final .ga-ph {
          border-color: var(--ga-border);
          background-color: var(--ga-bg-alt);
          box-shadow: none;
        }
        .ga-chip, .ga-hero-chips .ga-chip {
          color: var(--ga-text);
          background: var(--ga-card);
          border: 1px solid var(--ga-border);
          box-shadow: none;
          backdrop-filter: none;
        }
        .ga-btn { border-radius: .65rem; box-shadow: none; }
        .ga-btn-primary { background: var(--ga-button-primary); color: var(--ga-button-text); }
        .ga-btn-light { background: var(--ga-card); color: var(--ga-text); border: 1px solid var(--ga-border); }
        .ga-btn-ghost { background: transparent; color: var(--ga-text); border: 1px solid var(--ga-border); }
        .ga-percent {
          background: var(--ga-card);
          color: var(--ga-text);
          border: 1px solid var(--ga-border);
          border-radius: 16px;
          box-shadow: var(--ga-shadow);
        }
        .ga-percent::after { display: none; }
        .ga-percent-number { color: var(--ga-primary); }
        .ga-tile { overflow: hidden; }
        .ga-tile-label { background: linear-gradient(to top, rgba(15, 23, 42, .78), transparent); }
        @media (max-width: 768px) {
          .ga-section { padding: 2.75rem 1rem; }
          .ga-head { margin-bottom: 1.75rem; }
          .ga-title { font-size: clamp(1.55rem, 5vw, 1.9rem); line-height: 1.3; }
          .ga-sub { font-size: .94rem; line-height: 1.7; }
          .ga-card { padding: 1.2rem; border-radius: 14px; }
          .ga-card-title { font-size: 1.05rem; }
          .ga-card-text { font-size: .92rem; line-height: 1.65; }
          .ga-hero-title, .ga-final-title { font-size: clamp(1.7rem, 6vw, 2.2rem); }
          .ga-hero-lead { font-size: .95rem; }
        }
        @media (max-width: 480px) {
          .ga-section { padding: 2.25rem .9rem; }
          .ga-title { font-size: 1.5rem; }
          .ga-card { padding: 1rem; }
        }

        /* Home-page heading treatment and cleaner academy section rhythm. */
        .ga-root {
          font-family: inherit;
          line-height: 1.6;
        }
        .ga-section {
          padding: 4rem 1.5rem;
        }
        .ga-section--alt {
          background: var(--ga-bg-alt);
        }
        .ga-section--plain {
          background: var(--ga-bg);
        }
        .ga-head {
          text-align: center;
          margin: 0 auto 2.5rem;
        }
        .ga-title {
          color: var(--ga-text);
          font-size: clamp(1.8rem, 3vw, 2.5rem);
          font-weight: 700;
          line-height: 1.3;
          letter-spacing: -0.025em;
          padding: 0;
          margin: 0 0 .75rem;
          text-align: center;
        }
        .ga-title::after { display: none !important; }
        .ga-sub {
          color: var(--ga-text2);
          max-width: 820px;
          margin: 0 auto;
          font-size: 1rem;
          line-height: 1.8;
        }
        .ga-card {
          background: var(--ga-card);
          border: 1px solid color-mix(in srgb, var(--ga-text2) 18%, transparent);
          border-radius: 16px;
          box-shadow: var(--ga-shadow);
          padding: 1.6rem;
        }
        .ga-card:hover {
          transform: translateY(-3px);
          border-color: color-mix(in srgb, var(--ga-text2) 30%, transparent);
          box-shadow: var(--ga-shadow);
        }
        .ga-hero, .ga-final {
          background: var(--ga-bg);
          color: var(--ga-text);
        }
        .ga-hero-title, .ga-final-title {
          color: var(--ga-text);
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 700;
          line-height: 1.2;
          letter-spacing: -0.03em;
        }
        .ga-hero-lead, .ga-final-school, .ga-note, .ga-tagline {
          color: var(--ga-text2);
        }
        .ga-chip, .ga-hero-chips .ga-chip {
          color: var(--ga-text);
          background: var(--ga-card);
          border: 1px solid var(--ga-border);
          box-shadow: none;
        }
        .ga-btn-primary, .ga-node-year, .ga-check-mark {
          background: var(--ga-button-primary);
          color: var(--ga-button-text);
          box-shadow: none;
        }
        .ga-btn-outline, .ga-btn-light, .ga-btn-ghost {
          background: var(--ga-card);
          color: var(--ga-text);
          border: 1px solid var(--ga-border);
          box-shadow: none;
        }
        .ga-stat-value {
          color: var(--ga-primary);
          background: none;
          -webkit-text-fill-color: currentColor;
        }
        .ga-ph {
          border: 1px dashed color-mix(in srgb, var(--ga-text2) 35%, transparent);
          background-color: var(--ga-card);
          background-image: repeating-linear-gradient(135deg,
            color-mix(in srgb, var(--ga-text2) 5%, transparent) 0 10px,
            transparent 10px 22px);
        }
        @media (max-width: 768px) {
          .ga-section { padding: 2.75rem 1rem; }
          .ga-title { font-size: clamp(1.55rem, 5vw, 1.9rem); line-height: 1.3; }
          .ga-sub { font-size: .94rem; line-height: 1.7; }
          .ga-card { padding: 1.15rem; border-radius: 14px; }
          .ga-hero-title, .ga-final-title { font-size: clamp(1.7rem, 6vw, 2.25rem); }
        }
        @media (max-width: 480px) {
          .ga-section { padding: 2.25rem .9rem; }
          .ga-title { font-size: 1.5rem; }
          .ga-head { margin-bottom: 1.6rem; }
          .ga-card { padding: 1rem; }
        }

        `}</style>

      {/* 01 — HERO */}

      <section id="ga-hero" className="ga-section ga-hero">

        <div className="ga-wrap">

          <Placeholder size="hero" caption="Full-width photograph / video of the campus with students" />

          <h1 className="ga-hero-title">

            {"Strong Foundations. Advanced Learning. Limitless Possibilities."}

          </h1>

          <p className="ga-hero-lead">{HERO_LEAD}</p>

          <div className="ga-hero-chips">

            {HERO_CHIPS.map((chip) => (

              <span className="ga-chip" key={chip}>

                {chip}

              </span>

            ))}

          </div>

          <div className="ga-actions">

            <button className="ga-btn ga-btn-light" onClick={() => goTo("ga-glance")}>

              Explore Gurukul

            </button>

            <button className="ga-btn ga-btn-ghost" onClick={() => goTo("admission-inquiry")}>

              Admission Enquiry

            </button>

          </div>

          <p className="ga-note">{HERO_NOTE}</p>

        </div>

      </section>

      {/* 02 — SCHOOL AT A GLANCE */}

      <section id="ga-glance" className="ga-section ga-section--alt">

        <div className="ga-wrap">

          <SectionHead

            title="School at a Glance"

            sub="This gives parents an immediate understanding of the institution."

          />

          <motion.div

            className="ga-grid ga-grid-5"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {GLANCE.map((stat) => (

              <Reveal as={motion.div} key={stat.label} variants={zoomIn} className="ga-card ga-stat">

                <div className="ga-stat-value">

                  {stat.text ? stat.text : <Counter value={stat.value} suffix={stat.suffix} />}

                </div>

                <div className="ga-stat-label">{stat.label}</div>

              </Reveal>

            ))}

          </motion.div>

        </div>

      </section>

      {/* 03 — OUR JOURNEY */}

      <section id="ga-journey" className="ga-section ga-section--plain">

        <div className="ga-wrap">

          <SectionHead

            title="Our Journey"

            sub="From 54 Students to 770+ Students"

          />

          <div className="ga-timeline">

            {TIMELINE.map((node, index) => (

              <React.Fragment key={node.year}>

                <Reveal as={motion.div} variants={zoomIn} className="ga-card ga-node">

                  <span className="ga-node-year">{node.year}</span>

                  <p className="ga-card-text">{node.text}</p>

                </Reveal>

                {index < TIMELINE.length - 1 ? (

                  <div className="ga-node-arrow" aria-hidden="true">

                    →

                  </div>

                ) : null}

              </React.Fragment>

            ))}

          </div>

          <Reveal as={motion.div} variants={revealUp} className="ga-quote ga-mt-2">

            {JOURNEY_TEXT}

          </Reveal>

          <div className="ga-grid ga-grid-2 ga-mt-2">

            <Placeholder size="large" caption="Old photograph" />

            <Placeholder size="large" caption="Present-day campus photograph" />

          </div>

        </div>

      </section>

      {/* 04 — ACADEMIC EXCELLENCE */}

      <section id="ga-academics" className="ga-section ga-section--alt">

        <div className="ga-wrap">

          <SectionHead

            title="Academic Excellence"

            sub="Strong Foundations. Consistent Results."

          />

          <div className="ga-grid ga-grid-2" style={{ alignItems: "stretch" }}>

            <Reveal as={motion.div} variants={zoomIn}>

              <div className="ga-percent">

                <div className="ga-percent-number">100%</div>

                <div className="ga-percent-years">10 Consecutive Years</div>

                <div className="ga-percent-label">100% SSC &amp; HSC Board Results</div>

              </div>

            </Reveal>

            <Reveal as={motion.div} variants={revealUp} className="ga-card" style={{ display: "flex", alignItems: "center" }}>

              <p className="ga-card-text" style={{ fontSize: "1.05rem" }}>

                {ACADEMIC_PARAGRAPH}

              </p>

            </Reveal>

          </div>

          <motion.div

            className="ga-grid ga-grid-3 ga-mt-2"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {ACADEMIC_CARDS.map((card) => (

              <Reveal as={motion.div} key={card.title} variants={revealUp} className="ga-card">

                <div className="ga-icon" aria-hidden="true"><IconGlyph name={card.title === "Conceptual Learning" ? "book-open" : card.title === "Individual Attention" ? "user-round" : "check-circle"} /></div>

                <h3 className="ga-card-title">{card.title}</h3>

                <p className="ga-card-text">{card.text}</p>

              </Reveal>

            ))}

          </motion.div>

        </div>

      </section>

      {/* 05 — FUTURE-READY LEARNING */}

      <section id="ga-future" className="ga-section ga-section--plain">

        <div className="ga-wrap">

          <SectionHead

            title="Future-Ready Learning"

            sub="Advanced Education for a Changing World"

          />

          <motion.div

            className="ga-grid ga-grid-4"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {FUTURE_CARDS.map((card) => (

              <Reveal as={motion.div} key={card.title} variants={zoomIn} className="ga-card">

                <Placeholder size="medium" />

                <h3 className="ga-card-title" style={{ marginTop: "1rem" }}>

                  {card.title}

                </h3>

                <p className="ga-card-text">{card.text}</p>

              </Reveal>

            ))}

          </motion.div>

          <Reveal as={motion.div} variants={revealUp} className="ga-statement">

            {FUTURE_STATEMENT}

          </Reveal>

        </div>

      </section>

      {/* 06 — SPORTS EXCELLENCE */}

      <section id="ga-sports" className="ga-section ga-section--alt">

        <div className="ga-wrap">

          <SectionHead

            title="Sports Excellence"

            sub="From the Playground to the Podium"

          />

          <Placeholder size="feature" caption="Large sports photograph (background / feature image)" />

          <div className="ga-center">

            <div className="ga-levels">

              {SPORT_LEVELS.map((level, index) => (

                <React.Fragment key={level}>

                  <span className="ga-chip">{level}</span>

                  {index < SPORT_LEVELS.length - 1 ? (

                    <span className="ga-level-arrow" aria-hidden="true">

                      →

                    </span>

                  ) : null}

                </React.Fragment>

              ))}

            </div>

            <p className="ga-sub" style={{ margin: "0 auto 2rem" }}>

              {SPORTS_TEXT}

            </p>

          </div>

          <motion.div

            className="ga-grid ga-grid-3"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {SPORTS_GROUPS.map((group) => (

              <Reveal as={motion.div} key={group.title} variants={revealUp} className="ga-card">

                <div className="ga-icon"><IconGlyph name={group.icon} /></div>

                <h3 className="ga-card-title">{group.title}</h3>

                <div className="ga-sports-list">

                  {group.items.map((item) => (

                    <span className="ga-chip" key={item}>

                      {item}

                    </span>

                  ))}

                </div>

              </Reveal>

            ))}

          </motion.div>

          <div className="ga-center ga-mt-2" style={{ display: "flex", flexWrap: "wrap", gap: "0.7rem", justifyContent: "center" }}>

            {SPORTS_HIGHLIGHT.map((item) => (

              <span className="ga-chip" key={item}>

                {item}

              </span>

            ))}

          </div>

          <motion.div

            className="ga-mosaic ga-mt-2"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {SPORT_PHOTOS.map((photo) => (

              <Reveal

                as={motion.div}

                key={photo.label}

                variants={zoomIn}

                className={photo.wide ? "ga-tile--wide" : undefined}

              >

                <PhotoTile label={photo.label} />

              </Reveal>

            ))}

          </motion.div>

        </div>

      </section>

      {/* 07 — BEYOND ACADEMICS */}

      <section id="ga-beyond" className="ga-section ga-section--plain">

        <div className="ga-wrap">

          <SectionHead

            title="Beyond Academics"

            sub="Every Child Has a Talent. Give It a Platform."

          />

          <div className="ga-beyond-marquee" aria-label="Beyond Academics activities">

            <div className="ga-beyond-track">

              {[...BEYOND_CARDS, ...BEYOND_CARDS].map((card, index) => (

                <div

                  className="ga-card ga-center ga-beyond-card"

                  key={`${card.title}-${index}`}

                  aria-hidden={index >= BEYOND_CARDS.length ? "true" : undefined}

                >

                  <div className="ga-icon" style={{ margin: "0 auto 1rem" }}>

                    <IconGlyph name={card.icon} />

                  </div>

                  <h3 className="ga-card-title" style={{ fontSize: "1.05rem" }}>

                    {card.title}

                  </h3>

                </div>

              ))}

            </div>

          </div>

          <Reveal as={motion.p} variants={revealUp} className="ga-sub ga-mt-2">

            {BEYOND_TEXT}

          </Reveal>

          <div className="ga-grid ga-grid-3 ga-mt-2">

            <Placeholder size="large" caption="School activity photograph" />

            <Placeholder size="large" caption="School activity photograph" />

            <Placeholder size="large" caption="School activity photograph" />

          </div>

        </div>

      </section>

      {/* 08 — CAMPUS & INFRASTRUCTURE */}

      <section id="ga-campus" className="ga-section ga-section--alt">

        <div className="ga-wrap">

          <SectionHead

            title="Campus & Infrastructure"

            sub="A Campus Designed for Learning, Activity & Expression"

          />

          <motion.div

            className="ga-grid ga-grid-8"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {GALLERY_ITEMS.map((item) => (

              <Reveal as={motion.div} key={item} variants={zoomIn} className="ga-card" style={{ padding: "1rem" }}>

                <Placeholder size="medium" caption={item} />

              </Reveal>

            ))}

          </motion.div>

          <Reveal as={motion.p} variants={revealUp} className="ga-sub ga-mt-2">

            {CAMPUS_TEXT}

          </Reveal>

        </div>

      </section>

      {/* 09 — SPACES FOR EXPRESSION */}

      <section id="ga-spaces" className="ga-section ga-section--plain">

        <div className="ga-wrap">

          <SectionHead

            title="Spaces for Expression"

            sub="Learn. Perform. Express. Celebrate."

          />

          <div className="ga-grid ga-grid-2">

            {SPACES.map((space) => (

              <Reveal as={motion.div} key={space.title} variants={zoomIn} className="ga-card">

                <Placeholder size="large" caption={space.caption} />

                <h3 className="ga-card-title" style={{ marginTop: "1.1rem" }}>

                  {space.title}

                </h3>

                <p className="ga-card-text" style={{ fontWeight: 600, marginBottom: "0.25rem" }}>

                  For:

                </p>

                <ul className="ga-space-list">

                  {space.items.map((item) => (

                    <li key={item}>{item}</li>

                  ))}

                </ul>

              </Reveal>

            ))}

          </div>

        </div>

      </section>

      {/* 10 — STUDENT CARE */}

      <section id="ga-care" className="ga-section ga-section--alt">

        <div className="ga-wrap">

          <SectionHead

            title="Student Care"

            sub="More Than a School. A Complete Care Ecosystem."

          />

          <motion.div

            className="ga-grid ga-grid-4"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {CARE_CARDS.map((card) => (

              <Reveal as={motion.div} key={card.title} variants={revealUp} className="ga-card">

                <div className="ga-icon"><IconGlyph name={card.icon} /></div>

                <h3 className="ga-card-title">{card.title}</h3>

                <p className="ga-card-text">{card.text}</p>

              </Reveal>

            ))}

          </motion.div>

          <Reveal as={motion.div} variants={revealUp} className="ga-statement">

            {CARE_MESSAGE}

          </Reveal>

        </div>

      </section>

      {/* 11 — THE GURUKUL ADVANTAGE */}

      <section id="ga-advantage" className="ga-section ga-section--plain">

        <div className="ga-wrap">

          <SectionHead

            title="The Gurukul Advantage"

            sub="One School. Multiple Dimensions of Growth."

          />

          <motion.div

            className="ga-grid ga-grid-4"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {ADVANTAGE.map((item) => (

              <Reveal as={motion.div} key={item.title} variants={zoomIn} className="ga-card">

                <div className="ga-icon"><IconGlyph name={item.icon} /></div>

                <h3

                  className="ga-card-title"

                  style={{ textTransform: "uppercase", letterSpacing: "0.05em", fontSize: "1.05rem" }}

                >

                  {item.title}

                </h3>

                <p className="ga-card-text">{item.text}</p>

              </Reveal>

            ))}

          </motion.div>

        </div>

      </section>

      {/* 12 — WHY CHOOSE GURUKUL? */}

      <section id="ga-why" className="ga-section ga-section--alt">

        <div className="ga-wrap">

          <SectionHead

            title="Why Choose Gurukul?"

            sub="What Parents Look For. What Gurukul Strives to Provide."

          />

          <motion.div

            className="ga-grid ga-grid-2"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {WHY_LIST.map((item, index) => (

              <Reveal as={motion.div} key={item} variants={revealUp} className="ga-check">

                <span className="ga-check-mark">✓</span>

                <span className="ga-check-text">{item}</span>

              </Reveal>

            ))}

          </motion.div>

        </div>

      </section>

      {/* 13 — OUR EDUCATIONAL PHILOSOPHY */}

      <section id="ga-philosophy" className="ga-section ga-section--plain">

        <div className="ga-wrap">

          <SectionHead

            title="Our Educational Philosophy"

            sub="Every Child Has Potential. Our Responsibility Is to Help Them Discover It."

          />

          <motion.div

            className="ga-grid ga-grid-2"

            variants={staggerContainer}

            initial="hidden"

            whileInView="show"

            viewport={{ once: true }}

          >

            {PHILOSOPHY_PARAGRAPHS.map((paragraph) => (

              <Reveal as={motion.div} key={paragraph} variants={revealUp} className="ga-card">

                <p className="ga-card-text" style={{ fontSize: "1.05rem" }}>

                  {paragraph}

                </p>

              </Reveal>

            ))}

          </motion.div>

          <Reveal as={motion.div} variants={zoomIn} className="ga-percent ga-mt-2">

            <div style={{ fontSize: "clamp(1.3rem, 3vw, 2rem)", fontWeight: 700, lineHeight: 1.4 }}>

              {PHILOSOPHY_STATEMENT}

            </div>

          </Reveal>

        </div>

      </section>

      {/* 14 — FINAL ADMISSION CTA */}

      <section id="ga-admission" className="ga-section ga-final">

        <div className="ga-wrap">

          <Placeholder size="hero" caption="Campus / student image" />

          <h2 className="ga-final-title">

            {"Give Your Child the Right Environment to Learn, Grow & Excel."}

          </h2>

          <p className="ga-final-school">

            {"Gurukul English Medium School & Junior College, Abdul Lat"}

          </p>

          <span className="ga-badge">Nursery to Grade 12</span>

          <div className="ga-actions" style={{ justifyContent: "center" }}>

            <button className="ga-btn ga-btn-light" onClick={() => goTo("admission-inquiry")}>

              Enquire for Admission

            </button>

            <button className="ga-btn ga-btn-ghost" onClick={() => goTo("unit-contact")}>

              Book a Campus Visit

            </button>

          </div>

          <p className="ga-tagline">{"Growing with Trust. Inspiring Excellence."}</p>

        </div>

      </section>

    </div>

  );

};

export default EnglishAcademyShowcase;
